package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.background
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.AccountBox
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.ArrowBack
import androidx.compose.material.icons.filled.ArrowForward
import androidx.compose.material.icons.filled.Build
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Home
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.filled.List
import androidx.compose.material.icons.filled.LocationOn
import androidx.compose.material.icons.filled.Notifications
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Refresh
import androidx.compose.material.icons.filled.Star
import androidx.compose.material.icons.filled.Search
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.FilterChip
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import androidx.compose.ui.window.PopupProperties
import br.com.htms.inspeccaocampo.data.ativos.Ativo
import br.com.htms.inspeccaocampo.data.ativos.AtivoCategorias
import br.com.htms.inspeccaocampo.data.ativos.AtivoLog
import br.com.htms.inspeccaocampo.data.ativos.AtivoStatus
import br.com.htms.inspeccaocampo.data.ativos.AtivosApi
import br.com.htms.inspeccaocampo.data.ativos.AtivosDados
import br.com.htms.inspeccaocampo.data.ativos.StatusAnexos
import br.com.htms.inspeccaocampo.data.ativos.AtivosFormat
import br.com.htms.inspeccaocampo.data.ativos.CentroCusto
import br.com.htms.inspeccaocampo.data.ativos.Colaborador
import br.com.htms.inspeccaocampo.data.ativos.Fornecedor
import br.com.htms.inspeccaocampo.data.ativos.Movimentacao
import br.com.htms.inspeccaocampo.data.ativos.MovimentacaoTipo
import br.com.htms.inspeccaocampo.data.ativos.SolicStatus
import br.com.htms.inspeccaocampo.data.ativos.Solicitacao
import br.com.htms.inspeccaocampo.data.checklist.ChecklistCatalog
import br.com.htms.inspeccaocampo.data.os.PgrCatalog
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.ui.kit.CampoBusca
import br.com.htms.inspeccaocampo.ui.kit.Campo
import br.com.htms.inspeccaocampo.ui.kit.BotaoCores
import br.com.htms.inspeccaocampo.ui.kit.CartaoBranco
import br.com.htms.inspeccaocampo.ui.kit.CoresDash
import br.com.htms.inspeccaocampo.ui.kit.Celula
import br.com.htms.inspeccaocampo.ui.kit.CelulaCabecalho
import br.com.htms.inspeccaocampo.ui.kit.CelulaCabecalhoOrdenavel
import br.com.htms.inspeccaocampo.ui.kit.Ordenacao
import br.com.htms.inspeccaocampo.ui.kit.SeletorBusca
import br.com.htms.inspeccaocampo.ui.kit.Kpi
import br.com.htms.inspeccaocampo.ui.kit.Par
import br.com.htms.inspeccaocampo.ui.kit.PortalCabecalho
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuChips
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuItem
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuLateral
import br.com.htms.inspeccaocampo.ui.kit.PortalModal
import br.com.htms.inspeccaocampo.ui.kit.Seletor
import br.com.htms.inspeccaocampo.ui.kit.TabelaPortal
import br.com.htms.inspeccaocampo.ui.kit.LinhaTabela
import br.com.htms.inspeccaocampo.ui.dashboards.DashboardAtivos
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import br.com.htms.inspeccaocampo.platform.currentTimeMillis
import br.com.htms.inspeccaocampo.platform.formatDateBr
import br.com.htms.inspeccaocampo.platform.formatDateTimeBr
import br.com.htms.inspeccaocampo.shared.ui.components.AppDateTextField
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import br.com.htms.inspeccaocampo.shared.ui.components.DateFieldKind
import br.com.htms.inspeccaocampo.shared.ui.components.DateInputMask
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

private enum class AtivosAba(val rotulo: String, val icone: ImageVector) {
    PAINEL("Painel", Icons.Filled.Home),
    DASHBOARD("Dashboard", Icons.Filled.Star),
    SOLICITACOES("Solicitações", Icons.Filled.Notifications),
    ATIVOS("Ativos", Icons.Filled.List),
    MOVIMENTACOES("Movimentações", Icons.Filled.Refresh),
    CENTROS("Obras / Centros de custo", Icons.Filled.LocationOn),
    MANUTENCAO("Manutenção", Icons.Filled.Build),
    FORNECEDORES("Fornecedores", Icons.Filled.AccountBox),
    LOG("Log do módulo", Icons.Filled.Info)
}

private const val POLLING_MS = 15_000L

private val Navy get() = PortalCores.Navy
private val AzulIcone get() = PortalCores.AzulIcone
private val FundoPainel get() = PortalCores.FundoPainel
private val Borda get() = PortalCores.Borda
private val CabecalhoTabela get() = PortalCores.CabecalhoTabela
private val Verde get() = PortalCores.Verde
private val Laranja get() = PortalCores.Laranja
private val CinzaTexto get() = PortalCores.CinzaTexto

private fun norm(s: String): String = PgrCatalog.normalizar(s)

/** Cor do texto/borda e cor de fundo do chip de status. */
private fun coresStatus(status: String): Pair<Color, Color> = when (status) {
    "EM_USO" -> Color(0xFF1E7B3A) to Color(0xFFE8F5EC)
    "DISPONIVEL" -> Color(0xFF1E5AA8) to Color(0xFFE7F0FB)
    "MANUTENCAO" -> Color(0xFFD06A00) to Color(0xFFFFF3E5)
    "DEVOLVIDO" -> Color(0xFF5B6575) to Color(0xFFF0F2F5)
    "BAIXADO" -> Color(0xFFC62828) to Color(0xFFFDECEC)
    else -> Color(0xFF5B6575) to Color(0xFFF0F2F5)
}

private fun corMov(tipo: String): Color = when (tipo) {
    "CHEGADA" -> Color(0xFF2E9E4F)
    "TRANSFERENCIA" -> Color(0xFF7B4FC9)
    "MANUTENCAO" -> Color(0xFFE07B00)
    "RETORNO_MANUTENCAO" -> Color(0xFF1E6FD9)
    "DEVOLUCAO" -> Color(0xFF1E6FD9)
    "BAIXA" -> Color(0xFFC62828)
    else -> Color(0xFF8A94A6)
}

private fun iconeMov(tipo: String): ImageVector = when (tipo) {
    "CHEGADA" -> Icons.Filled.ArrowForward
    "TRANSFERENCIA" -> Icons.Filled.Refresh
    "MANUTENCAO" -> Icons.Filled.Build
    "RETORNO_MANUTENCAO" -> Icons.Filled.Check
    "DEVOLUCAO" -> Icons.Filled.ArrowBack
    "BAIXA" -> Icons.Filled.Delete
    else -> Icons.Filled.Edit
}

private fun verboMov(tipo: String): String = when (tipo) {
    "CHEGADA" -> "registrou chegada"
    "TRANSFERENCIA" -> "transferiu"
    "MANUTENCAO" -> "enviou para manutenção"
    "RETORNO_MANUTENCAO" -> "registrou retorno"
    "DEVOLUCAO" -> "devolveu"
    "BAIXA" -> "deu baixa"
    else -> "editou"
}

private fun ehAlmoxarifado(a: Ativo, ccPorId: Map<String, CentroCusto>): Boolean {
    val cc = ccPorId[a.centroCustoId] ?: return a.status == "DISPONIVEL"
    return cc.codigo.startsWith("200") || norm(cc.nome).contains("almox") || a.status == "DISPONIVEL"
}

@Composable
fun SharedAtivosScreen(controller: AppController) {
    val scope = rememberCoroutineScope()
    var dados by remember { mutableStateOf<AtivosDados?>(null) }
    var erro by remember { mutableStateOf<String?>(null) }
    var aviso by remember { mutableStateOf<String?>(null) }
    var atualizadoEm by remember { mutableStateOf("") }
    var aba by remember { mutableStateOf(AtivosAba.PAINEL) }
    var buscaAtivos by remember { mutableStateOf("") }
    var veioDoPainel by remember { mutableStateOf(false) }
    val irPara: (AtivosAba) -> Unit = {
        aba = it
        veioDoPainel = false
    }
    var recarregarTick by remember { mutableStateOf(0) }
    var novoAtivo by remember { mutableStateOf(false) }
    var novaMov by remember { mutableStateOf(false) }
    var novaLocacao by remember { mutableStateOf(false) }
    var obraPainel by remember { mutableStateOf("") }

    suspend fun carregar(completo: Boolean) {
        val versao = if (completo) 0L else dados?.versao ?: 0L
        AtivosApi.dados(versao)
            .onSuccess { novo ->
                if (novo != null) dados = novo
                erro = null
                atualizadoEm = formatDateBr(currentTimeMillis()).substringAfter(' ')
            }
            .onFailure { erro = it.message ?: "Falha ao carregar o Controle de Ativos." }
    }

    LaunchedEffect(recarregarTick) {
        carregar(completo = true)
        while (true) {
            delay(POLLING_MS)
            carregar(completo = false)
        }
    }

    val recarregar: () -> Unit = { recarregarTick++ }
    val avisar: (String) -> Unit = { aviso = it }
    val d = dados
    val pendentes = d?.pendentesParaMim()?.size ?: 0
    val abasVisiveis = AtivosAba.entries.filter { d == null || d.podeVer(it.name) }
    LaunchedEffect(d?.abasModo, d?.centrosLimitados) {
        val atual = d ?: return@LaunchedEffect
        if (!atual.podeVer(aba.name)) {
            aba = AtivosAba.entries.firstOrNull { atual.podeVer(it.name) } ?: aba
        }
    }

    BoxWithConstraints(Modifier.fillMaxSize().background(FundoPainel)) {
        val largo = maxWidth >= 900.dp
        Row(Modifier.fillMaxSize()) {
            if (largo) MenuLateral(aba = aba, pendentes = pendentes, visiveis = abasVisiveis, onAba = irPara)
            Column(Modifier.weight(1f).fillMaxHeight()) {
                Cabecalho(controller, largo = largo, atualizadoEm = atualizadoEm, erro = erro != null)
                val rolagem258 = androidx.compose.foundation.rememberScrollState()
                br.com.htms.inspeccaocampo.ui.kit.AreaRolavel(rolagem258, Modifier
                        .fillMaxSize()) {
                Column(
                    modifier = Modifier.fillMaxSize().verticalScroll(rolagem258).padding(if (largo) 24.dp else 12.dp),
                    verticalArrangement = Arrangement.spacedBy(18.dp)
                ) {
                    if (!largo) MenuChips(aba = aba, pendentes = pendentes, visiveis = abasVisiveis, onAba = irPara)
                    if (d?.centrosLimitados == true) {
                        Text(
                            "Você vê somente os centros de custo liberados para o seu usuário.",
                            style = MaterialTheme.typography.bodySmall,
                            color = CinzaTexto
                        )
                    }
                    aviso?.let { msg ->
                        Card(colors = CardDefaults.cardColors(containerColor = Color(0xFFE7F3EA))) {
                            Row(Modifier.fillMaxWidth().padding(horizontal = 14.dp, vertical = 6.dp), verticalAlignment = Alignment.CenterVertically) {
                                Text(msg, Modifier.weight(1f), style = MaterialTheme.typography.bodyMedium, color = Verde)
                                TextButton(onClick = { aviso = null }) { Text("OK") }
                            }
                        }
                    }
                    erro?.let { Text(it, color = MaterialTheme.colorScheme.error) }
                    if (d == null) {
                        if (erro == null) CircularProgressIndicator(color = Navy)
                    } else if (abasVisiveis.isEmpty()) {
                        Text("Nenhuma aba do Controle de Ativos foi liberada para o seu usuário.")
                    } else {
                        if (aba == AtivosAba.PAINEL) {
                            if (pendentes > 0) AvisoPendentes(pendentes) { irPara(AtivosAba.SOLICITACOES) }
                            FiltroObra(d, obraPainel) { obraPainel = it }
                        }
                        when (aba) {
                            AtivosAba.PAINEL -> PainelAtivos(
                                d = filtrarPorObra(d, obraPainel),
                                largo = largo,
                                onAbrirAtivo = { codigo ->
                                    buscaAtivos = codigo
                                    aba = AtivosAba.ATIVOS
                                    veioDoPainel = true
                                },
                                onVerTodos = {
                                    buscaAtivos = ""
                                    aba = AtivosAba.ATIVOS
                                    veioDoPainel = true
                                },
                                onNovaMov = { novaMov = true },
                                onLerQr = { avisar("A leitura de QR Code chega na próxima etapa do Controle de Ativos.") }
                            )
                            AtivosAba.DASHBOARD -> DashboardAtivos(d) { recarregar() }
                            AtivosAba.ATIVOS, AtivosAba.MANUTENCAO -> key(aba, buscaAtivos) {
                                ListaAtivos(
                                    d = d,
                                    largo = largo,
                                    titulo = if (aba == AtivosAba.MANUTENCAO) "Ativos em manutenção" else "Ativos",
                                    statusInicial = if (aba == AtivosAba.MANUTENCAO) "MANUTENCAO" else "POSSE",
                                    buscaInicial = if (aba == AtivosAba.ATIVOS) buscaAtivos else "",
                                    scope = scope,
                                    avisar = avisar,
                                    recarregar = recarregar,
                                    onNovoAtivo = { novoAtivo = true },
                                    onNovaMov = { novaMov = true },
                                    onVoltar = if (veioDoPainel && aba == AtivosAba.ATIVOS) ({ irPara(AtivosAba.PAINEL) }) else null
                                )
                            }
                            AtivosAba.SOLICITACOES -> ListaSolicitacoes(
                                d,
                                scope = scope,
                                avisar = avisar,
                                recarregar = recarregar,
                                onNovaLocacao = { novaLocacao = true }
                            )
                            AtivosAba.MOVIMENTACOES -> ListaMovimentacoes(d, scope = scope, avisar = avisar, recarregar = recarregar)
                            AtivosAba.FORNECEDORES -> ListaFornecedores(d, scope = scope, avisar = avisar, recarregar = recarregar)
                            AtivosAba.CENTROS -> ListaCentros(d, scope = scope, avisar = avisar, recarregar = recarregar)
                            AtivosAba.LOG -> LogAtivos(scope = scope, avisar = avisar)
                        }
                    }
                }
                }
            }
        }
    }

    if (d != null && novoAtivo) {
        ModalAtivos(onFechar = { novoAtivo = false }) {
            AtivoForm(
                inicial = Ativo(dataChegada = hojeIso()),
                d = d,
                master = d.podeExcluir,
                scope = scope,
                onFechar = { novoAtivo = false },
                avisar = avisar,
                recarregar = recarregar
            )
        }
    }
    if (d != null && novaMov) {
        ModalAtivos(onFechar = { novaMov = false }) {
            NovaMovimentacao(d, scope, onFechar = { novaMov = false }, avisar = avisar, recarregar = recarregar)
        }
    }
    if (d != null && novaLocacao) {
        ModalAtivos(onFechar = { novaLocacao = false }) {
            LocacaoForm(d, scope, onFechar = { novaLocacao = false }, avisar = avisar, recarregar = recarregar)
        }
    }
}

private fun filtrarPorObra(d: AtivosDados, cc: String): AtivosDados =
    if (cc.isBlank()) d
    else d.copy(
        ativos = d.ativos.filter { it.centroCustoId == cc },
        movimentacoes = d.movimentacoes.filter { it.paraCentroCustoId == cc || it.deCentroCustoId == cc }
    )

@Composable
private fun FiltroObra(d: AtivosDados, selecionado: String, onSelect: (String) -> Unit) {
    Box(Modifier.widthIn(min = 260.dp, max = 460.dp)) {
        SeletorBusca(
            label = "Filtrar por obra / centro de custo",
            opcoes = listOf("" to "Todas as obras") + d.centrosCusto.map { it.id to it.rotulo + if (!it.ativo) " (inativa)" else "" },
            selecionado = selecionado,
            onSelect = onSelect
        )
    }
}

@Composable
private fun AvisoPendentes(qtd: Int, onAbrir: () -> Unit) {
    Card(
        colors = CardDefaults.cardColors(containerColor = Color(0xFFFFF4EA)),
        modifier = Modifier.fillMaxWidth().border(1.dp, Color(0xFFFBD9B5), RoundedCornerShape(12.dp)).clickable { onAbrir() },
        shape = RoundedCornerShape(12.dp)
    ) {
        Row(Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 12.dp), verticalAlignment = Alignment.CenterVertically) {
            Icon(Icons.Filled.Notifications, contentDescription = null, tint = Laranja)
            Spacer(Modifier.width(10.dp))
            Text(
                if (qtd == 1) "1 solicitação aguardando sua ação" else "$qtd solicitações aguardando sua ação",
                Modifier.weight(1f),
                color = Color(0xFF8A4B00),
                fontWeight = FontWeight.SemiBold
            )
            Text("Abrir", color = Navy, fontWeight = FontWeight.SemiBold)
        }
    }
}

// ---------------------------------------------------------------- Estrutura (menu / cabeçalho)

private fun rotuloAba(a: AtivosAba, pendentes: Int): String =
    if (a == AtivosAba.SOLICITACOES && pendentes > 0) "${a.rotulo} ($pendentes)" else a.rotulo

private fun itensMenu(pendentes: Int, visiveis: List<AtivosAba>): List<PortalMenuItem> = visiveis.map {
    PortalMenuItem(it.name, rotuloAba(it, pendentes), it.icone, destaque = it == AtivosAba.SOLICITACOES && pendentes > 0)
}

@Composable
private fun MenuLateral(aba: AtivosAba, pendentes: Int, visiveis: List<AtivosAba>, onAba: (AtivosAba) -> Unit) =
    PortalMenuLateral(itensMenu(pendentes, visiveis), aba.name) { onAba(AtivosAba.valueOf(it)) }

@Composable
private fun MenuChips(aba: AtivosAba, pendentes: Int, visiveis: List<AtivosAba>, onAba: (AtivosAba) -> Unit) =
    PortalMenuChips(itensMenu(pendentes, visiveis), aba.name) { onAba(AtivosAba.valueOf(it)) }

@Composable
private fun Cabecalho(controller: AppController, largo: Boolean, atualizadoEm: String, erro: Boolean) {
    PortalCabecalho("Controle de Ativos e Ferramentas", largo) {
        BotaoPlanilha(controller, br.com.htms.inspeccaocampo.export.PlanilhaModulo.ATIVOS)
        Spacer(Modifier.width(14.dp))
        val corVivo = if (erro) Color(0xFFC62828) else Color(0xFF2E9E4F)
        Box(Modifier.size(10.dp).background(corVivo, CircleShape))
        Spacer(Modifier.width(8.dp))
        Column {
            Text(if (erro) "Sem conexão" else "Ao vivo", color = corVivo, fontWeight = FontWeight.SemiBold, style = MaterialTheme.typography.bodyMedium)
            if (atualizadoEm.isNotBlank() && largo) {
                Text("atualizado $atualizadoEm", color = CinzaTexto, style = MaterialTheme.typography.labelSmall)
            }
        }
    }
}

@Composable
private fun ModalAtivos(onFechar: () -> Unit, content: @Composable () -> Unit) = PortalModal(onFechar, content = content)

// ---------------------------------------------------------------- Painel

@Composable
private fun PainelAtivos(
    d: AtivosDados,
    largo: Boolean,
    onAbrirAtivo: (String) -> Unit,
    onVerTodos: () -> Unit,
    onNovaMov: () -> Unit,
    onLerQr: () -> Unit
) {
    val ccPorId = d.centrosCusto.associateBy { it.id }
    val ativoPorId = d.ativos.associateBy { it.id }
    val emPosse = d.ativos.filter { it.emPosse }
    val manut = emPosse.count { it.status == "MANUTENCAO" }
    val almox = emPosse.count { it.status != "MANUTENCAO" && ehAlmoxarifado(it, ccPorId) }
    val emUso = emPosse.count { it.status == "EM_USO" && !ehAlmoxarifado(it, ccPorId) }
    BotaoCores(
        listOf(
            "Total de ativos" to 0xFF1E5AA8,
            "Em uso nas obras" to 0xFF1565C0,
            "No almoxarifado" to 0xFF0097A7,
            "Em manutenção" to 0xFFE07B00
        )
    )

    val kpis: @Composable (Modifier) -> Unit = { m ->
        Kpi("Total de ativos", emPosse.size.toString(), Icons.Filled.List, m, cor = CoresDash.de("Total de ativos", 0xFF1E5AA8))
        Kpi("Em uso nas obras", emUso.toString(), Icons.Filled.Person, m, cor = CoresDash.de("Em uso nas obras", 0xFF1565C0))
        Kpi("No almoxarifado", almox.toString(), Icons.Filled.Home, m, cor = CoresDash.de("No almoxarifado", 0xFF0097A7))
        Kpi("Em manutenção", manut.toString(), Icons.Filled.Settings, m, cor = CoresDash.de("Em manutenção", 0xFFE07B00), alerta = true)
    }
    if (largo) {
        Row(horizontalArrangement = Arrangement.spacedBy(18.dp), modifier = Modifier.fillMaxWidth()) {
            kpis(Modifier.weight(1f))
        }
    } else {
        Column(verticalArrangement = Arrangement.spacedBy(10.dp)) { kpis(Modifier.fillMaxWidth()) }
    }

    val cartaoAtivos: @Composable (Modifier) -> Unit = { m ->
        CartaoAtivosPainel(d, emPosse, ccPorId, largo, m, onAbrirAtivo, onVerTodos, onNovaMov, onLerQr)
    }
    val feed = d.movimentacoes.take(12)
    if (largo) {
        Row(horizontalArrangement = Arrangement.spacedBy(18.dp), verticalAlignment = Alignment.Top, modifier = Modifier.fillMaxWidth()) {
            cartaoAtivos(Modifier.weight(2.1f))
            FeedTempoReal(feed, ativoPorId, ccPorId, Modifier.weight(1f))
        }
    } else {
        cartaoAtivos(Modifier.fillMaxWidth())
        FeedTempoReal(feed, ativoPorId, ccPorId, Modifier.fillMaxWidth())
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun CartaoAtivosPainel(
    d: AtivosDados,
    emPosse: List<Ativo>,
    ccPorId: Map<String, CentroCusto>,
    largo: Boolean,
    modifier: Modifier,
    onAbrirAtivo: (String) -> Unit,
    onVerTodos: () -> Unit,
    onNovaMov: () -> Unit,
    onLerQr: () -> Unit
) {
    var busca by remember { mutableStateOf("") }
    val termo = norm(busca.trim())
    val lista = emPosse
        .filter { a ->
            termo.isEmpty() || norm(
                listOf(a.codigo, a.descricao, a.modelo, a.placaPatrimonio, a.responsavel, ccPorId[a.centroCustoId]?.rotulo.orEmpty())
                    .joinToString(" ")
            ).contains(termo)
        }
        .sortedByDescending { it.updatedAt }
    CartaoBranco(modifier) {
        Column(Modifier.padding(22.dp), verticalArrangement = Arrangement.spacedBy(16.dp)) {
            Text("Ativos", color = Navy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge)
            val botoes: @Composable () -> Unit = {
                Button(
                    onClick = onNovaMov,
                    enabled = d.podeEditar("MOVIMENTACOES"),
                    colors = ButtonDefaults.buttonColors(containerColor = Navy),
                    shape = RoundedCornerShape(10.dp),
                    modifier = Modifier.height(52.dp)
                ) {
                    Icon(Icons.Filled.Add, contentDescription = null, modifier = Modifier.size(18.dp))
                    Spacer(Modifier.width(6.dp))
                    Text("Nova movimentação")
                }
                OutlinedButton(onClick = onLerQr, shape = RoundedCornerShape(10.dp), modifier = Modifier.height(52.dp)) {
                    Text("Ler QR Code", color = Navy)
                }
            }
            if (largo) {
                Row(horizontalArrangement = Arrangement.spacedBy(12.dp), verticalAlignment = Alignment.CenterVertically) {
                    CampoBusca(busca, { busca = it }, "Buscar por código, nome ou QR Code", Modifier.weight(1f))
                    botoes()
                }
            } else {
                CampoBusca(busca, { busca = it }, "Buscar por código, nome ou QR Code", Modifier.fillMaxWidth())
                FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) { botoes() }
            }
            val visiveis = lista.take(10)
            if (largo) {
                TabelaAtivos(visiveis, ccPorId, emptyMap(), completa = false, selecionadoId = null, onSelecionar = { onAbrirAtivo(it.codigo) })
            } else {
                visiveis.forEach { a ->
                    Column(Modifier.clickable { onAbrirAtivo(a.codigo) }) { CartaoAtivoCompacto(a, ccPorId, emptyMap()) }
                }
            }
            if (lista.isEmpty()) Text("Nenhum ativo encontrado.", color = CinzaTexto)
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(
                    "Mostrando ${visiveis.size} de ${lista.size} · custo mensal ${AtivosFormat.moeda(emPosse.filter { it.alugado }.sumOf { it.valorMes ?: 0.0 })}",
                    color = CinzaTexto,
                    style = MaterialTheme.typography.bodySmall,
                    modifier = Modifier.weight(1f)
                )
                TextButton(onClick = onVerTodos) { Text("Ver todos os ativos", color = AzulIcone) }
            }
        }
    }
}

@Composable
private fun FeedTempoReal(
    movs: List<Movimentacao>,
    ativoPorId: Map<String, Ativo>,
    ccPorId: Map<String, CentroCusto>,
    modifier: Modifier
) {
    CartaoBranco(modifier) {
        Column(Modifier.padding(22.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
            Text("Movimentações em tempo real", color = Navy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge)
            Spacer(Modifier.height(10.dp))
            if (movs.isEmpty()) Text("Nenhuma movimentação ainda.", color = CinzaTexto)
            movs.forEachIndexed { i, m ->
                ItemFeed(m, ativoPorId[m.ativoId], ccPorId, ultimo = i == movs.lastIndex)
            }
        }
    }
}

private fun horaMov(m: Movimentacao): String {
    if (m.createdBy == "importacao" || m.createdAt <= 0L) return AtivosFormat.dataBr(m.data)
    val completo = formatDateBr(m.createdAt)
    val hoje = formatDateBr(currentTimeMillis()).substringBefore(' ')
    val dia = completo.substringBefore(' ')
    val hora = completo.substringAfter(' ', "")
    return if (dia == hoje) hora else "${dia.take(5)} $hora".trim()
}

@Composable
private fun ItemFeed(
    m: Movimentacao,
    ativo: Ativo?,
    ccPorId: Map<String, CentroCusto>,
    ultimo: Boolean = true,
    onExcluir: (() -> Unit)? = null
) {
    val quem = if (m.createdBy == "importacao") "Planilha" else m.createdBy.ifBlank { "Sistema" }
    val destino = when (m.tipo) {
        "MANUTENCAO" -> "Manutenção"
        "DEVOLUCAO" -> "Fornecedor"
        "BAIXA", "EDICAO" -> null
        else -> ccPorId[m.paraCentroCustoId]?.nome
    }
    Row(Modifier.fillMaxWidth()) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Box(Modifier.size(36.dp).background(corMov(m.tipo), CircleShape), contentAlignment = Alignment.Center) {
                Icon(iconeMov(m.tipo), contentDescription = null, tint = Color.White, modifier = Modifier.size(20.dp))
            }
            if (!ultimo) Box(Modifier.width(2.dp).heightIn(min = 46.dp).background(Borda))
        }
        Spacer(Modifier.width(14.dp))
        Column(Modifier.weight(1f).padding(bottom = 14.dp), verticalArrangement = Arrangement.spacedBy(2.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(horaMov(m), color = Navy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.bodyMedium)
                Spacer(Modifier.width(10.dp))
                Text(
                    "$quem ${verboMov(m.tipo)}",
                    color = Color(0xFF2B3546),
                    style = MaterialTheme.typography.bodyMedium,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
            Text(
                ativo?.let { "${it.descricao} ${it.codigo}" } ?: "Ativo removido",
                color = Navy,
                fontWeight = FontWeight.Bold,
                style = MaterialTheme.typography.bodyMedium,
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
            if (destino != null) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Filled.ArrowForward, contentDescription = null, tint = CinzaTexto, modifier = Modifier.size(14.dp))
                    Spacer(Modifier.width(4.dp))
                    Text(destino, color = CinzaTexto, style = MaterialTheme.typography.bodySmall, maxLines = 1, overflow = TextOverflow.Ellipsis)
                }
            }
            if (m.tipo == "EDICAO" && m.observacao.isNotBlank()) {
                Text(m.observacao, color = CinzaTexto, style = MaterialTheme.typography.bodySmall, maxLines = 2, overflow = TextOverflow.Ellipsis)
            }
        }
        if (onExcluir != null) {
            TextButton(onClick = onExcluir) {
                Icon(Icons.Filled.Delete, contentDescription = null, tint = Color(0xFFC62828), modifier = Modifier.size(18.dp))
                Spacer(Modifier.width(4.dp))
                Text("Excluir", color = Color(0xFFC62828))
            }
        }
    }
}

// ---------------------------------------------------------------- Tabela de ativos

@Composable
private fun ChipStatus(status: String) {
    val (cor, fundo) = coresStatus(status)
    Text(
        AtivoStatus.rotulo(status),
        color = cor,
        fontWeight = FontWeight.SemiBold,
        style = MaterialTheme.typography.labelMedium,
        maxLines = 1,
        modifier = Modifier
            .background(fundo, RoundedCornerShape(8.dp))
            .border(1.dp, cor.copy(alpha = 0.55f), RoundedCornerShape(8.dp))
            .padding(horizontal = 10.dp, vertical = 4.dp)
    )
}

@Composable
private fun TabelaAtivos(
    lista: List<Ativo>,
    ccPorId: Map<String, CentroCusto>,
    fornPorId: Map<String, Fornecedor>,
    completa: Boolean,
    selecionadoId: String?,
    onSelecionar: (Ativo) -> Unit,
    detalhe: @Composable (Ativo) -> Unit = {},
    statusAnexos: ((Ativo) -> StatusAnexos)? = null,
    onAnexos: ((Ativo, GrupoAnexo) -> Unit)? = null,
    ordemCol: String = "",
    ordemAsc: Boolean = true,
    onOrdenar: ((String) -> Unit)? = null,
    fixar: Boolean = false,
    acima: @Composable ColumnScope.() -> Unit = {}
) {
    @Composable
    fun RowScope.Cab(texto: String, peso: Float, chave: String) {
        if (onOrdenar == null) CelulaCabecalho(texto, peso)
        else CelulaCabecalhoOrdenavel(texto, peso, if (ordemCol == chave) ordemAsc else null) { onOrdenar(chave) }
    }
    Column(Modifier.fillMaxWidth().border(1.dp, Borda, RoundedCornerShape(10.dp))) {
        val cabecalho: @Composable () -> Unit = {
            Column(Modifier.fillMaxWidth().background(PortalCores.Cartao)) {
                acima()
                Row(
                    Modifier.fillMaxWidth().background(CabecalhoTabela, RoundedCornerShape(topStart = 10.dp, topEnd = 10.dp))
                        .padding(horizontal = 16.dp, vertical = 12.dp)
                ) {
            Cab("Código", 0.9f, "CODIGO")
            Cab("Tipo de equipamento", 1.8f, "TIPO")
            Cab("Categoria", 1.2f, "CATEGORIA")
            Cab("Local atual", 1.6f, "LOCAL")
            Cab("Responsável", 1.2f, "RESPONSAVEL")
            if (completa) {
                Cab("Fornecedor", 1.4f, "FORNECEDOR")
                Cab("Valor mês", 1.0f, "VALOR")
            }
            Cab("Status", 1.1f, "STATUS")
            if (statusAnexos != null) GrupoAnexo.entries.forEach { CabecalhoAnexo(it, Modifier.weight(0.65f)) }
                }
            }
        }
        if (fixar) br.com.htms.inspeccaocampo.ui.kit.PainelFixo { cabecalho() } else cabecalho()
        lista.forEach { a ->
            HorizontalDivider(color = Borda)
            val sel = a.id == selecionadoId
            Row(
                Modifier
                    .fillMaxWidth()
                    .background(if (sel) Navy.copy(alpha = 0.05f) else Color.Transparent)
                    .clickable { onSelecionar(a) }
                    .padding(horizontal = 16.dp, vertical = 12.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Celula(a.codigo, 0.9f, negrito = true, cor = Navy)
                Celula(a.descricao, 1.8f)
                Celula(a.categoria.ifBlank { "—" }, 1.2f)
                Celula(ccPorId[a.centroCustoId]?.nome ?: "—", 1.6f)
                Celula(a.responsavel.ifBlank { "—" }, 1.2f)
                if (completa) {
                    Celula(fornPorId[a.fornecedorId]?.nome ?: if (a.alugado) "—" else "Próprio", 1.4f)
                    Celula(AtivosFormat.moeda(a.valorMes), 1.0f)
                }
                Box(Modifier.weight(1.1f)) { ChipStatus(a.status) }
                if (statusAnexos != null) {
                    val st = statusAnexos(a)
                    GrupoAnexo.entries.forEach { g -> CelulaAnexo(g, st, Modifier.weight(0.65f)) { onAnexos?.invoke(a, g) } }
                }
            }
            if (sel) detalhe(a)
        }
    }
}

@Composable
private fun CartaoAtivoCompacto(
    a: Ativo,
    ccPorId: Map<String, CentroCusto>,
    fornPorId: Map<String, Fornecedor>,
    rodape: (@Composable () -> Unit)? = null
) {
    Column(Modifier.fillMaxWidth().padding(vertical = 8.dp), verticalArrangement = Arrangement.spacedBy(3.dp)) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Text(a.codigo, color = Navy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.bodyMedium)
            Spacer(Modifier.width(8.dp))
            Text(a.descricao, Modifier.weight(1f), style = MaterialTheme.typography.bodyMedium, maxLines = 2, overflow = TextOverflow.Ellipsis)
            ChipStatus(a.status)
        }
        Text(
            listOfNotNull(
                a.categoria.ifBlank { null },
                ccPorId[a.centroCustoId]?.nome,
                a.responsavel.ifBlank { null },
                fornPorId[a.fornecedorId]?.nome
            ).joinToString(" · "),
            style = MaterialTheme.typography.bodySmall,
            color = CinzaTexto
        )
        rodape?.invoke()
    }
    HorizontalDivider(color = Borda)
}

// ---------------------------------------------------------------- Aba Ativos / Manutenção

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun ListaAtivos(
    d: AtivosDados,
    largo: Boolean,
    titulo: String,
    statusInicial: String,
    buscaInicial: String,
    scope: CoroutineScope,
    avisar: (String) -> Unit,
    recarregar: () -> Unit,
    onNovoAtivo: () -> Unit,
    onNovaMov: () -> Unit,
    onVoltar: (() -> Unit)? = null
) {
    var busca by remember { mutableStateOf(buscaInicial) }
    var filtroStatus by remember { mutableStateOf(statusInicial) }
    var filtroCc by remember { mutableStateOf("") }
    var filtroAnexo by remember { mutableStateOf(FiltroAnexo.TODOS) }
    var ordemCol by remember { mutableStateOf("") }
    var ordemAsc by remember { mutableStateOf(true) }
    val ordenar: (String) -> Unit = { col ->
        if (ordemCol == col) ordemAsc = !ordemAsc else {
            ordemCol = col
            ordemAsc = true
        }
    }
    var selecionadoId by remember {
        mutableStateOf(d.ativos.firstOrNull { buscaInicial.isNotBlank() && it.codigo.equals(buscaInicial, ignoreCase = true) }?.id)
    }
    var editando by remember { mutableStateOf<Ativo?>(null) }
    var movendo by remember { mutableStateOf<Ativo?>(null) }
    var excluindoMov by remember { mutableStateOf<Movimentacao?>(null) }
    var historicoId by remember { mutableStateOf<String?>(null) }
    var anexosDe by remember { mutableStateOf<Pair<String, GrupoAnexo>?>(null) }
    val ccPorId = d.centrosCusto.associateBy { it.id }
    val fornPorId = d.fornecedores.associateBy { it.id }

    CartaoBranco(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(22.dp), verticalArrangement = Arrangement.spacedBy(14.dp)) {
            val termo = norm(busca.trim())
            val base = d.ativos.filter { a ->
                (filtroStatus == "" || (filtroStatus == "POSSE" && a.emPosse) || a.status == filtroStatus) &&
                    (filtroCc == "" || a.centroCustoId == filtroCc) &&
                    (termo.isEmpty() || norm(
                        listOf(a.codigo, a.descricao, a.modelo, a.placaPatrimonio, a.responsavel, a.categoria,
                            fornPorId[a.fornecedorId]?.nome.orEmpty(), ccPorId[a.centroCustoId]?.rotulo.orEmpty()
                        ).joinToString(" ")
                    ).contains(termo))
            }
            val lista = base.filter { filtroAnexo.atende(d.statusAnexos(it.id)) }.let { l ->
                val cmp: Comparator<Ativo>? = when (ordemCol) {
                    "CODIGO" -> Ordenacao.por(ordemAsc) { it.codigo }
                    "TIPO" -> Ordenacao.por(ordemAsc) { it.descricao }
                    "CATEGORIA" -> Ordenacao.por(ordemAsc) { it.categoria }
                    "LOCAL" -> Ordenacao.por(ordemAsc) { ccPorId[it.centroCustoId]?.nome.orEmpty() }
                    "RESPONSAVEL" -> Ordenacao.por(ordemAsc) { it.responsavel }
                    "FORNECEDOR" -> Ordenacao.por(ordemAsc) { fornPorId[it.fornecedorId]?.nome ?: if (it.alugado) "" else "Próprio" }
                    "VALOR" -> Ordenacao.porNumero(ordemAsc) { it.valorMes }
                    "STATUS" -> Ordenacao.por(ordemAsc) { AtivoStatus.rotulo(it.status) }
                    else -> null
                }
                if (cmp == null) l else l.sortedWith(cmp)
            }

            val detalhe: @Composable (Ativo) -> Unit = { a ->
                Column(
                    Modifier.fillMaxWidth().background(Navy.copy(alpha = 0.04f)).padding(horizontal = 16.dp, vertical = 10.dp),
                    verticalArrangement = Arrangement.spacedBy(6.dp)
                ) {
                    Text(
                        buildList {
                            if (a.categoria.isNotBlank()) add(a.categoria)
                            if (a.placaPatrimonio.isNotBlank()) add("Placa/Patr.: ${a.placaPatrimonio}")
                            if (a.dataChegada.isNotBlank()) add("Chegada: ${AtivosFormat.dataBr(a.dataChegada)}")
                            if (a.dataEntrega.isNotBlank()) add("Entrega: ${AtivosFormat.dataBr(a.dataEntrega)}")
                            if (a.dataInicioContrato.isNotBlank() || a.dataTerminoContrato.isNotBlank()) {
                                add("Contrato: ${AtivosFormat.dataBr(a.dataInicioContrato).ifBlank { "?" }} a ${AtivosFormat.dataBr(a.dataTerminoContrato).ifBlank { "?" }}")
                            }
                            a.valorDia?.let { add("Dia: ${AtivosFormat.moeda(it)}") }
                            a.valorEquipamento?.let { add("Equip.: ${AtivosFormat.moeda(it)}") }
                            a.valorEmAberto?.let { add("Em aberto: ${AtivosFormat.moeda(it)}") }
                            a.mesesParaValorEquipamento?.let { add("${AtivosFormat.numero1(it)} meses = valor do equip.") }
                            if (a.inspecaoTipo.isNotBlank()) add("Inspeção: ${a.inspecaoTipo}")
                        }.joinToString(" · "),
                        style = MaterialTheme.typography.bodySmall
                    )
                    if (a.observacoes.isNotBlank()) Text(a.observacoes, style = MaterialTheme.typography.bodySmall, color = CinzaTexto)
                    FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                        if (d.podeEditar("ATIVOS")) {
                            Button(onClick = { editando = a }, colors = ButtonDefaults.buttonColors(containerColor = Navy)) { Text("Editar") }
                        }
                        OutlinedButton(onClick = { movendo = a }) { Text("Movimentar") }
                        TextButton(onClick = { historicoId = if (historicoId == a.id) null else a.id }) {
                            Text(if (historicoId == a.id) "Ocultar histórico" else "Histórico")
                        }
                    }
                    if (historicoId == a.id) {
                        val movs = d.movimentacoes.filter { it.ativoId == a.id }
                        if (movs.isEmpty()) Text("Sem movimentações.", style = MaterialTheme.typography.bodySmall)
                        movs.forEachIndexed { i, m ->
                            ItemFeed(m, a, ccPorId, ultimo = i == movs.lastIndex, onExcluir = if (d.podeExcluir) ({ excluindoMov = m }) else null)
                        }
                    }
                }
            }

            val painelAtivos: @Composable ColumnScope.() -> Unit = {
                        FlowRow(
                            horizontalArrangement = Arrangement.spacedBy(10.dp),
                            verticalArrangement = Arrangement.spacedBy(8.dp),
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            if (onVoltar != null) {
                                OutlinedButton(onClick = onVoltar, shape = RoundedCornerShape(10.dp)) {
                                    Icon(Icons.Filled.ArrowBack, contentDescription = null, tint = Navy, modifier = Modifier.size(18.dp))
                                    Spacer(Modifier.width(6.dp))
                                    Text("Voltar ao painel", color = Navy)
                                }
                            }
                            Text(titulo, color = Navy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge, modifier = Modifier.padding(end = 20.dp, top = 8.dp))
                            if (d.podeEditar("MOVIMENTACOES")) {
                                Button(onClick = onNovaMov, colors = ButtonDefaults.buttonColors(containerColor = Navy), shape = RoundedCornerShape(10.dp)) {
                                    Icon(Icons.Filled.Add, contentDescription = null, modifier = Modifier.size(18.dp))
                                    Spacer(Modifier.width(6.dp))
                                    Text("Nova movimentação")
                                }
                            }
                            if (d.podeEditar("ATIVOS")) {
                                OutlinedButton(onClick = onNovoAtivo, shape = RoundedCornerShape(10.dp)) { Text("Cadastrar ativo", color = Navy) }
                            }
                        }
                        CampoBusca(busca, { busca = it }, "Buscar por código, nome, placa, fornecedor ou responsável", Modifier.fillMaxWidth())
                        FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                            Box(Modifier.widthIn(min = 260.dp, max = 420.dp)) {
                                SeletorBusca(
                                    label = "Obra / centro de custo",
                                    opcoes = listOf("" to "Todos") + d.centrosCusto.map { it.id to it.rotulo },
                                    selecionado = filtroCc,
                                    onSelect = { filtroCc = it }
                                )
                            }
                            FilterChip(selected = filtroStatus == "POSSE", onClick = { filtroStatus = "POSSE" }, label = { Text("Em posse") })
                            FilterChip(selected = filtroStatus == "", onClick = { filtroStatus = "" }, label = { Text("Todos") })
                            AtivoStatus.todos.forEach { (id, rot) ->
                                FilterChip(selected = filtroStatus == id, onClick = { filtroStatus = id }, label = { Text(rot) })
                            }
                        }
                        FiltroAnexos(base, d, filtroAnexo) { filtroAnexo = it }
                        Text(
                            "${lista.size} ativo(s) · custo mensal ${AtivosFormat.moeda(lista.filter { it.alugado && it.emPosse }.sumOf { it.valorMes ?: 0.0 })} · clique na linha para editar, movimentar ou ver o histórico · use os ícones de foto, documento e contrato para anexar arquivos",
                            style = MaterialTheme.typography.bodySmall,
                            color = CinzaTexto
                        )
            }
            if (largo) {
                TabelaAtivos(
                    lista, ccPorId, fornPorId,
                    completa = true,
                    selecionadoId = selecionadoId,
                    onSelecionar = { selecionadoId = if (selecionadoId == it.id) null else it.id },
                    detalhe = detalhe,
                    statusAnexos = { d.statusAnexos(it.id) },
                    onAnexos = { a, g -> anexosDe = a.id to g },
                    ordemCol = ordemCol,
                    ordemAsc = ordemAsc,
                    onOrdenar = ordenar,
                    fixar = true,
                    acima = painelAtivos
                )
            } else {
                br.com.htms.inspeccaocampo.ui.kit.PainelFixo {
                    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(10.dp), content = painelAtivos)
                }
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp), verticalAlignment = Alignment.CenterVertically) {
                    Seletor(
                        "Ordenar por",
                        listOf(
                            "" to "Padrão", "CODIGO" to "Código", "TIPO" to "Tipo de equipamento", "CATEGORIA" to "Categoria", "LOCAL" to "Local atual",
                            "RESPONSAVEL" to "Responsável", "FORNECEDOR" to "Fornecedor", "VALOR" to "Valor mês", "STATUS" to "Status"
                        ),
                        ordemCol,
                        { ordemCol = it },
                        Modifier.weight(1f)
                    )
                    OutlinedButton(onClick = { ordemAsc = !ordemAsc }, enabled = ordemCol.isNotBlank()) {
                        Text(if (ordemAsc) "Crescente" else "Decrescente", color = Navy)
                    }
                }
                lista.forEach { a ->
                    Column(Modifier.clickable { selecionadoId = if (selecionadoId == a.id) null else a.id }) {
                        CartaoAtivoCompacto(a, ccPorId, fornPorId) {
                            ResumoAnexos(d.statusAnexos(a.id)) { g -> anexosDe = a.id to g }
                        }
                    }
                    if (selecionadoId == a.id) detalhe(a)
                }
            }
            if (lista.isEmpty()) Text("Nenhum ativo encontrado.", color = CinzaTexto)
        }
    }

    anexosDe?.let { (id, g) ->
        d.ativos.firstOrNull { it.id == id }?.let { a ->
            AnexosAtivoDialog(a, d, g, onFechar = { anexosDe = null }, avisar = avisar, recarregar = recarregar, editar = d.podeEditar("ATIVOS"))
        }
    }
    editando?.let { a ->
        ModalAtivos(onFechar = { editando = null }) {
            AtivoForm(a, d, d.podeExcluir, scope, onFechar = { editando = null }, avisar = avisar, recarregar = recarregar)
        }
    }
    movendo?.let { a ->
        ModalAtivos(onFechar = { movendo = null }) {
            MovimentarForm(a, d, scope, onFechar = { movendo = null }, avisar = avisar, recarregar = recarregar)
        }
    }
    excluindoMov?.let { m ->
        ConfirmarExclusaoMov(m, d.ativos.firstOrNull { it.id == m.ativoId }, scope, onFechar = { excluindoMov = null }, avisar = avisar, recarregar = recarregar)
    }
}

private fun hojeIso(): String =
    AtivosFormat.dataIso(DateInputMask.now(DateFieldKind.DATE)).orEmpty()

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun AtivoForm(
    inicial: Ativo,
    d: AtivosDados,
    master: Boolean,
    scope: CoroutineScope,
    onFechar: () -> Unit,
    avisar: (String) -> Unit,
    recarregar: () -> Unit
) {
    var a by remember(inicial.id) { mutableStateOf(inicial) }
    var dataBr by remember(inicial.id) { mutableStateOf(AtivosFormat.dataBr(inicial.dataChegada)) }
    var inicioContratoBr by remember(inicial.id) { mutableStateOf(AtivosFormat.dataBr(inicial.dataInicioContrato)) }
    var terminoContratoBr by remember(inicial.id) { mutableStateOf(AtivosFormat.dataBr(inicial.dataTerminoContrato)) }
    var entregaBr by remember(inicial.id) { mutableStateOf(AtivosFormat.dataBr(inicial.dataEntrega)) }
    var valorMes by remember(inicial.id) { mutableStateOf(AtivosFormat.editarMoeda(inicial.valorMes)) }
    var valorEq by remember(inicial.id) { mutableStateOf(AtivosFormat.editarMoeda(inicial.valorEquipamento)) }
    var valorAberto by remember(inicial.id) { mutableStateOf(AtivosFormat.editarMoeda(inicial.valorEmAberto)) }
    var valorCompra by remember(inicial.id) { mutableStateOf(AtivosFormat.editarMoeda(inicial.valorFinalCompra)) }
    var salvando by remember { mutableStateOf(false) }
    var erroLocal by remember { mutableStateOf<String?>(null) }
    var confirmarRemocao by remember { mutableStateOf(false) }
    var cadastrandoFornecedor by remember { mutableStateOf(false) }
    var fornecedoresNovos by remember { mutableStateOf(listOf<Fornecedor>()) }
    val novo = inicial.id.isBlank()
    val fornecedores = (d.fornecedores + fornecedoresNovos).distinctBy { it.id }
    val valorDia = AtivosFormat.parseMoeda(valorMes)?.takeIf { it > 0 }?.div(30.0)

    CartaoBranco(Modifier.fillMaxWidth()) {
        BoxWithConstraints(Modifier.fillMaxWidth()) {
            val duas = maxWidth >= 560.dp
            Column(Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                Text(
                    if (novo) "Cadastrar novo ativo" else "Editar ativo ${inicial.codigo}",
                    fontWeight = FontWeight.Bold,
                    style = MaterialTheme.typography.titleLarge,
                    color = Navy
                )
                Par(duas,
                    { m -> Seletor("Categoria", listOf("" to "—") + AtivoCategorias.todas.map { it to it }, a.categoria, { a = a.copy(categoria = it) }, m) },
                    { m -> Campo("Código (vazio = automático)", a.codigo, modifier = m) { a = a.copy(codigo = it) } }
                )
                Campo("Descrição *", a.descricao) { a = a.copy(descricao = it) }
                Par(duas,
                    { m -> Campo("Modelo / tipo", a.modelo, modifier = m) { a = a.copy(modelo = it) } },
                    { m -> Campo("Placa / Patrimônio", a.placaPatrimonio, modifier = m) { a = a.copy(placaPatrimonio = it) } }
                )
                Text("Propriedade", style = MaterialTheme.typography.bodySmall, color = CinzaTexto)
                FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                    FilterChip(selected = a.propriedade == "ALUGADO", onClick = { a = a.copy(propriedade = "ALUGADO") }, label = { Text("Alugado") })
                    FilterChip(selected = a.propriedade == "PROPRIO", onClick = { a = a.copy(propriedade = "PROPRIO") }, label = { Text("Próprio") })
                }
                Par(duas,
                    { m ->
                        Seletor(
                            "Fornecedor",
                            listOf("" to "—") + fornecedores.filter { it.ativo || it.id == a.fornecedorId }.map { it.id to it.nome },
                            a.fornecedorId,
                            { a = a.copy(fornecedorId = it) },
                            m
                        )
                    },
                    { m ->
                        SeletorBusca(
                            "Centro de custo (obra)",
                            listOf("" to "—") + d.centrosCusto.filter { it.ativo || it.id == a.centroCustoId }.map { it.id to it.rotulo },
                            a.centroCustoId,
                            { id ->
                                val admObra = d.centrosCusto.firstOrNull { it.id == id }?.admUsername.orEmpty()
                                val nomeAdm = d.usuarios.firstOrNull { it.username.equals(admObra, true) }?.nomeOuLogin.orEmpty()
                                a = a.copy(
                                    centroCustoId = id,
                                    responsavel = if (a.responsavel.isBlank() && nomeAdm.isNotBlank()) nomeAdm else a.responsavel
                                )
                            },
                            m
                        )
                    }
                )
                if (cadastrandoFornecedor) {
                    FornecedorForm(
                        inicial = Fornecedor(id = "", nome = ""),
                        cadastrados = fornecedores,
                        scope = scope,
                        onFechar = { cadastrandoFornecedor = false },
                        avisar = avisar,
                        recarregar = recarregar,
                        onSalvo = { salvo ->
                            fornecedoresNovos = fornecedoresNovos + salvo
                            a = a.copy(fornecedorId = salvo.id)
                            cadastrandoFornecedor = false
                        }
                    )
                } else if (d.podeEditar("FORNECEDORES") || d.podeEditar("ATIVOS")) {
                    TextButton(onClick = { cadastrandoFornecedor = true }) { Text("Cadastrar fornecedor") }
                }
                Par(duas,
                    { m ->
                        val adms = d.usuariosAdm.map { it.nomeOuLogin to it.nomeOuLogin }
                        val atual = a.responsavel.takeIf { r -> r.isNotBlank() && adms.none { it.first == r } }
                        Seletor(
                            "ADM responsável",
                            listOf("" to "—") + adms + listOfNotNull(atual?.let { it to "$it (cadastro antigo)" }),
                            a.responsavel,
                            { a = a.copy(responsavel = it) },
                            m
                        )
                    },
                    { m -> AppDateTextField(value = dataBr, onValueChange = { dataBr = it }, label = "Data de chegada", modifier = m) }
                )
                Par(duas,
                    { m -> AppDateTextField(value = entregaBr, onValueChange = { entregaBr = it }, label = "Data de entrega", modifier = m) },
                    { m -> Spacer(m) }
                )
                Par(duas,
                    { m -> AppDateTextField(value = inicioContratoBr, onValueChange = { inicioContratoBr = it }, label = "Início do contrato", modifier = m) },
                    { m -> AppDateTextField(value = terminoContratoBr, onValueChange = { terminoContratoBr = it }, label = "Término do contrato", modifier = m) }
                )
                Par(duas,
                    { m -> Campo("Valor mês (R$)", valorMes, numero = true, modifier = m) { valorMes = it } },
                    { m -> Campo("Valor dia (automático)", valorDia?.let { AtivosFormat.editarMoeda(it) } ?: "", somenteLeitura = true, modifier = m) {} }
                )
                Par(duas,
                    { m -> Campo("Valor do equipamento (R$)", valorEq, numero = true, modifier = m) { valorEq = it } },
                    { m -> Campo("Valor em aberto (R$)", valorAberto, numero = true, modifier = m) { valorAberto = it } }
                )
                Par(duas,
                    { m -> Campo("Valor final de compra (R$)", valorCompra, numero = true, modifier = m) { valorCompra = it } },
                    { m -> Campo("Utilização (ex.: Rotineiro, Pontual)", a.utilizacao, modifier = m) { a = a.copy(utilizacao = it) } }
                )
                Par(duas,
                    { m ->
                        Seletor(
                            "Inspeção obrigatória (Inspeção HTMS)",
                            listOf("" to "Nenhuma") + ChecklistCatalog.tipos.map { it.nome to it.nome },
                            a.inspecaoTipo,
                            { a = a.copy(inspecaoTipo = it) },
                            m
                        )
                    },
                    { m -> Seletor("Status", AtivoStatus.todos, a.status, { a = a.copy(status = it) }, m) }
                )
                Campo("Observações", a.observacoes, linhas = 3) { a = a.copy(observacoes = it) }
                erroLocal?.let { Text(it, color = MaterialTheme.colorScheme.error) }
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp, Alignment.End), verticalAlignment = Alignment.CenterVertically) {
                    if (!novo && master) {
                        TextButton(onClick = {
                            if (!confirmarRemocao) {
                                confirmarRemocao = true
                                return@TextButton
                            }
                            scope.launch {
                                AtivosApi.removerAtivo(inicial.id)
                                    .onSuccess {
                                        avisar("Ativo ${inicial.codigo} removido.")
                                        onFechar()
                                        recarregar()
                                    }
                                    .onFailure { erroLocal = it.message ?: "Falha ao remover." }
                            }
                        }) {
                            Text(
                                if (confirmarRemocao) "Confirmar remoção" else "Remover (cadastro errado)",
                                color = MaterialTheme.colorScheme.error
                            )
                        }
                        Spacer(Modifier.weight(1f))
                    }
                    OutlinedButton(onClick = onFechar) { Text("Cancelar") }
                    Button(
                        enabled = !salvando,
                        colors = ButtonDefaults.buttonColors(containerColor = Navy),
                        onClick = {
                            val iso = AtivosFormat.dataIso(dataBr)
                            val isoEntrega = AtivosFormat.dataIso(entregaBr)
                            val isoInicio = AtivosFormat.dataIso(inicioContratoBr)
                            val isoTermino = AtivosFormat.dataIso(terminoContratoBr)
                            val valores = listOf(valorMes, valorEq, valorAberto, valorCompra).map {
                                it to AtivosFormat.parseMoeda(it)
                            }
                            erroLocal = when {
                                a.descricao.trim().length < 3 -> "Informe a descrição."
                                iso == null -> "Data de chegada inválida (dd/mm/aaaa)."
                                isoEntrega == null -> "Data de entrega inválida (dd/mm/aaaa)."
                                isoInicio == null -> "Data de início do contrato inválida (dd/mm/aaaa)."
                                isoTermino == null -> "Data de término do contrato inválida (dd/mm/aaaa)."
                                isoInicio.isNotBlank() && isoTermino.isNotBlank() && isoTermino < isoInicio ->
                                    "O término do contrato não pode ser antes do início."
                                valores.any { (txt, v) -> txt.isNotBlank() && v == null } -> "Valor inválido. Use por exemplo 2.450,00"
                                else -> null
                            }
                            if (erroLocal != null) return@Button
                            salvando = true
                            val enviar = a.copy(
                                dataChegada = iso.orEmpty(),
                                dataEntrega = isoEntrega.orEmpty(),
                                dataInicioContrato = isoInicio.orEmpty(),
                                dataTerminoContrato = isoTermino.orEmpty(),
                                valorMes = valores[0].second,
                                valorEquipamento = valores[1].second,
                                valorEmAberto = valores[2].second,
                                valorFinalCompra = valores[3].second
                            )
                            scope.launch {
                                AtivosApi.salvarAtivo(enviar)
                                    .onSuccess {
                                        avisar(if (novo) "Ativo ${it.codigo} cadastrado." else "Ativo ${it.codigo} atualizado.")
                                        onFechar()
                                        recarregar()
                                    }
                                    .onFailure { erroLocal = it.message ?: "Falha ao salvar." }
                                salvando = false
                            }
                        }
                    ) { Text(if (salvando) "Salvando…" else "Salvar ativo") }
                }
            }
        }
    }
}

@Composable
private fun NovaMovimentacao(
    d: AtivosDados,
    scope: CoroutineScope,
    onFechar: () -> Unit,
    avisar: (String) -> Unit,
    recarregar: () -> Unit
) {
    var ativoId by remember { mutableStateOf("") }
    var modo by remember { mutableStateOf("MOV") }
    if (modo == "LOCACAO") {
        LocacaoForm(d, scope, onFechar = onFechar, avisar = avisar, recarregar = recarregar, onVoltar = { modo = "MOV" })
        return
    }
    val ativo = d.ativos.firstOrNull { it.id == ativoId }
    if (ativo == null) {
        CartaoBranco(Modifier.fillMaxWidth()) {
            Column(Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                Text("Nova movimentação", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge, color = Navy)
                Seletor(
                    label = "Tipo",
                    opcoes = listOf(
                        "MOV" to "Movimentar um ativo existente",
                        "LOCACAO" to "LOCAÇÃO - solicitar veículo locado"
                    ),
                    selecionado = modo,
                    onSelect = { modo = it }
                )
                SeletorBusca(
                    label = "Escolha o ativo",
                    opcoes = listOf("" to "—") + d.ativos.filter { it.emPosse }.map { it.id to "${it.codigo} · ${it.descricao}" },
                    selecionado = ativoId,
                    onSelect = { ativoId = it }
                )
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
                    OutlinedButton(onClick = onFechar) { Text("Cancelar") }
                }
            }
        }
    } else {
        MovimentarForm(ativo, d, scope, onFechar = onFechar, avisar = avisar, recarregar = recarregar)
    }
}

@Composable
private fun MovimentarForm(
    a: Ativo,
    d: AtivosDados,
    scope: CoroutineScope,
    onFechar: () -> Unit,
    avisar: (String) -> Unit,
    recarregar: () -> Unit
) {
    var tipo by remember { mutableStateOf("TRANSFERENCIA") }
    var destino by remember { mutableStateOf("") }
    var responsavel by remember { mutableStateOf(a.responsavel) }
    var data by remember { mutableStateOf(DateInputMask.now(DateFieldKind.DATE)) }
    var obs by remember { mutableStateOf("") }
    var salvando by remember { mutableStateOf(false) }
    var erroLocal by remember { mutableStateOf<String?>(null) }
    val precisaDestino = tipo == "TRANSFERENCIA" || tipo == "CHEGADA"
    val direto = d.aprovaObra(a.centroCustoId.ifBlank { destino })
    val ccAtual = d.centrosCusto.firstOrNull { it.id == a.centroCustoId }?.rotulo ?: "Sem centro de custo"

    CartaoBranco(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
            Text("Nova movimentação", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge, color = Navy)
            Text("${a.codigo} · ${a.descricao}", fontWeight = FontWeight.SemiBold)
            Text("Atual: $ccAtual · ${AtivoStatus.rotulo(a.status)}", style = MaterialTheme.typography.bodySmall, color = CinzaTexto)
            if (a.inspecaoTipo.isNotBlank()) {
                Text("Inspeção vinculada: ${a.inspecaoTipo}", style = MaterialTheme.typography.bodySmall, color = Color(0xFF0D47A1))
            }
            Seletor(label = "O que aconteceu?", opcoes = MovimentacaoTipo.registraveis, selecionado = tipo, onSelect = { tipo = it })
            if (precisaDestino) {
                SeletorBusca(
                    label = "Para (centro de custo de destino)",
                    opcoes = listOf("" to "—") + d.centrosCusto.filter { it.ativo && it.id != a.centroCustoId }.map { it.id to it.rotulo },
                    selecionado = destino,
                    onSelect = { destino = it }
                )
            }
            CampoColaborador("Responsável", responsavel, d.colaboradores) { responsavel = it }
            AppDateTextField(value = data, onValueChange = { data = it }, label = "Data")
            Campo("Observação (motivo, nota, OS de manutenção…)", obs, linhas = 2) { obs = it }
            if (!direto) {
                Text(
                    "Esta movimentação vira uma solicitação e só é aplicada depois que o Engenheiro/Supervisor da obra aprovar.",
                    style = MaterialTheme.typography.bodySmall,
                    color = Laranja
                )
            }
            erroLocal?.let { Text(it, color = MaterialTheme.colorScheme.error) }
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp, Alignment.End)) {
                OutlinedButton(onClick = onFechar) { Text("Cancelar") }
                Button(
                    enabled = !salvando,
                    colors = ButtonDefaults.buttonColors(containerColor = Navy),
                    onClick = {
                        val iso = AtivosFormat.dataIso(data)
                        erroLocal = when {
                            iso.isNullOrBlank() -> "Informe a data (dd/mm/aaaa)."
                            precisaDestino && destino.isBlank() -> "Escolha o centro de custo de destino."
                            else -> null
                        }
                        if (erroLocal != null) return@Button
                        salvando = true
                        scope.launch {
                            AtivosApi.movimentar(a.id, tipo, if (precisaDestino) destino else "", responsavel, iso!!, obs)
                                .onSuccess { aplicada ->
                                    avisar(
                                        if (aplicada) "${MovimentacaoTipo.rotulo(tipo)} registrada para ${a.codigo}."
                                        else "Solicitação de ${MovimentacaoTipo.rotulo(tipo).lowercase()} de ${a.codigo} enviada para aprovação do Engenheiro/Supervisor da obra."
                                    )
                                    onFechar()
                                    recarregar()
                                }
                                .onFailure { erroLocal = it.message ?: "Falha ao registrar." }
                            salvando = false
                        }
                    }
                ) { Text(if (salvando) "Enviando…" else if (direto) "Confirmar movimentação" else "Enviar para aprovação") }
            }
        }
    }
}

// ---------------------------------------------------------------- Movimentações

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun ListaMovimentacoes(
    d: AtivosDados,
    scope: CoroutineScope,
    avisar: (String) -> Unit,
    recarregar: () -> Unit
) {
    var excluindoMov by remember { mutableStateOf<Movimentacao?>(null) }
    var busca by remember { mutableStateOf("") }
    var filtroTipo by remember { mutableStateOf("") }
    var filtroCc by remember { mutableStateOf("") }
    val ccPorId = d.centrosCusto.associateBy { it.id }
    val ativoPorId = d.ativos.associateBy { it.id }
    CartaoBranco(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
            Text("Movimentações", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge)
            AppOutlinedTextField(
                value = busca,
                onValueChange = { busca = it },
                label = { Text("Buscar (ativo, responsável, usuário, observação)") },
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
                colors = FormFieldDefaults.textFieldColors()
            )
            FiltroObra(d, filtroCc) { filtroCc = it }
            val tipos = listOf("CHEGADA", "TRANSFERENCIA", "MANUTENCAO", "RETORNO_MANUTENCAO", "DEVOLUCAO", "BAIXA", "EDICAO")
            FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                FilterChip(selected = filtroTipo == "", onClick = { filtroTipo = "" }, label = { Text("Todas") })
                tipos.forEach { t ->
                    FilterChip(selected = filtroTipo == t, onClick = { filtroTipo = t }, label = { Text(MovimentacaoTipo.rotulo(t)) })
                }
            }
            val termo = norm(busca.trim())
            val lista = d.movimentacoes.filter { m ->
                (filtroTipo == "" || m.tipo == filtroTipo) &&
                    (filtroCc == "" || m.deCentroCustoId == filtroCc || m.paraCentroCustoId == filtroCc) &&
                    (termo.isEmpty() || norm(
                        listOf(
                            ativoPorId[m.ativoId]?.codigo.orEmpty(), ativoPorId[m.ativoId]?.descricao.orEmpty(),
                            m.responsavel, m.createdBy, m.observacao
                        ).joinToString(" ")
                    ).contains(termo))
            }
            Text("${lista.size} movimentação(ões)", style = MaterialTheme.typography.bodySmall, color = CinzaTexto)
            lista.take(300).forEach {
                val mov = it
                ItemFeed(mov, ativoPorId[mov.ativoId], ccPorId, onExcluir = if (d.podeExcluir) ({ excluindoMov = mov }) else null)
                HorizontalDivider(color = Color(0xFFE6E9EF))
            }
            if (lista.size > 300) Text("Mostrando as 300 mais recentes — refine a busca.", style = MaterialTheme.typography.bodySmall)
            if (lista.isEmpty()) Text("Nenhuma movimentação encontrada.")
        }
    }
    excluindoMov?.let { m ->
        ConfirmarExclusaoMov(m, ativoPorId[m.ativoId], scope, onFechar = { excluindoMov = null }, avisar = avisar, recarregar = recarregar)
    }
}

@Composable
private fun TabelaLarga(minimo: androidx.compose.ui.unit.Dp, conteudo: @Composable () -> Unit) {
    BoxWithConstraints(Modifier.fillMaxWidth()) {
        val w = if (maxWidth < minimo) minimo else maxWidth
        Column(Modifier.fillMaxWidth().horizontalScroll(rememberScrollState())) {
            Box(Modifier.width(w)) { conteudo() }
        }
    }
}

private fun corAcaoLog(acao: String): Color = when {
    acao.endsWith("DELETE") || acao.endsWith("REMOVIDO") -> PortalCores.Vermelho
    acao == "ATIVO_CREATE" || acao == "ATIVO_ANEXO" -> Verde
    acao.contains("MOV") -> Laranja
    else -> Navy
}

private fun detalheLegivel(detalhe: String): String {
    val bruto = detalhe.trim()
    if (bruto.isEmpty()) return "—"
    val textos = bruto.split(';', ',').map { it.trim() }.filter { it.isNotEmpty() }.map { pedaco ->
        val i = pedaco.indexOf('=')
        if (i <= 0) rotuloSoltoLog(pedaco) else {
            val chave = pedaco.substring(0, i).trim()
            val valor = pedaco.substring(i + 1).trim()
            if (valor.isEmpty() || chave == "ativoId" || chave == "anexoId" || chave == "id") ""
            else rotuloCampoLog(chave, valor)
        }
    }.filter { it.isNotEmpty() }
    return if (textos.isEmpty()) "—" else textos.joinToString(" · ")
}

private fun rotuloSoltoLog(s: String): String = when (s.uppercase()) {
    "TRANSFERENCIA" -> "Transferência"
    "MANUTENCAO" -> "Manutenção"
    "RETORNO_MANUTENCAO" -> "Retorno de manutenção"
    "DEVOLUCAO" -> "Devolução"
    "BAIXA" -> "Baixa"
    "CHEGADA" -> "Chegada"
    "CADASTRO" -> "Cadastro"
    "EDICAO" -> "Edição"
    "LOCACAO" -> "Locação"
    "APROVADA-DIRETO" -> "Aprovada direto"
    else -> s
}

private fun rotuloCampoLog(chave: String, valor: String): String = when (chave) {
    "grupo" -> when (valor.uppercase()) {
        "FOTO" -> "Foto"
        "DOC" -> "Documento"
        "CONTRATO" -> "Contrato"
        else -> valor
    }
    "item" -> "Item $valor"
    "bytes" -> valor.toLongOrNull()?.let { n ->
        when {
            n >= 1_048_576 -> "${n / 1_048_576} MB"
            n >= 1024 -> "${n / 1024} KB"
            else -> "$n bytes"
        }
    } ?: valor
    "na" -> if (valor == "1" || valor.equals("true", true)) "Marcado como não se aplica" else "Voltou a exigir o anexo"
    "para" -> "Para $valor"
    "usuario" -> "Usuário $valor"
    "email" -> "E-mail $valor"
    "eng" -> "Engenheiro $valor"
    "adm" -> "ADM $valor"
    "obs", "observacao" -> valor
    "veiculo" -> "Veículo $valor"
    "data" -> "Data $valor"
    "por" -> "Registrado por $valor"
    "revertido" -> if (valor == "1" || valor.equals("true", true)) "Movimentação desfeita" else ""
    "solicitacao" -> ""
    else -> "$chave $valor"
}

// ---------------------------------------------------------------- Log do módulo

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun LogAtivos(scope: CoroutineScope, avisar: (String) -> Unit) {
    var logs by remember { mutableStateOf<List<AtivoLog>?>(null) }
    var busca by remember { mutableStateOf("") }
    var filtroAcao by remember { mutableStateOf("") }
    fun carregar() {
        scope.launch {
            AtivosApi.log()
                .onSuccess { logs = it }
                .onFailure {
                    if (logs == null) logs = emptyList()
                    avisar(it.message ?: "Falha ao carregar o log")
                }
        }
    }
    LaunchedEffect(Unit) { carregar() }
    CartaoBranco(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(
                    "Log do Controle de Ativos",
                    fontWeight = FontWeight.Bold,
                    style = MaterialTheme.typography.titleLarge,
                    modifier = Modifier.weight(1f)
                )
                TextButton(onClick = { carregar() }) {
                    Icon(Icons.Filled.Refresh, contentDescription = null, modifier = Modifier.size(18.dp))
                    Spacer(Modifier.width(4.dp))
                    Text("Atualizar")
                }
            }
            Text(
                "Registro separado do log geral: cadastros, edições, movimentações e exclusões feitas neste módulo.",
                style = MaterialTheme.typography.bodySmall,
                color = CinzaTexto
            )
            AppOutlinedTextField(
                value = busca,
                onValueChange = { busca = it },
                label = { Text("Buscar (usuário, ativo, detalhe)") },
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
                colors = FormFieldDefaults.textFieldColors()
            )
            FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                FilterChip(selected = filtroAcao == "", onClick = { filtroAcao = "" }, label = { Text("Todas") })
                AtivoLog.ACOES.forEach { a ->
                    FilterChip(selected = filtroAcao == a, onClick = { filtroAcao = a }, label = { Text(AtivoLog.rotuloAcao(a)) })
                }
            }
            val todos = logs
            if (todos == null) {
                CircularProgressIndicator(color = Navy)
            } else {
                val termo = norm(busca.trim())
                val lista = todos.filter { l ->
                    (filtroAcao == "" || l.acao == filtroAcao) &&
                        (termo.isEmpty() || norm("${l.usuario} ${l.nome} ${l.acaoRotulo} ${l.alvo} ${l.detalhe}").contains(termo))
                }
                Text("${lista.size} registro(s)", style = MaterialTheme.typography.bodySmall, color = CinzaTexto)
                if (lista.isEmpty()) {
                    Text("Nenhum registro encontrado.")
                } else {
                    TabelaLarga(980.dp) {
                        TabelaPortal(
                            cabecalho = {
                                CelulaCabecalho("Quando", 1.2f)
                                CelulaCabecalho("Ação", 1.35f)
                                CelulaCabecalho("Registro", 1.15f)
                                CelulaCabecalho("Detalhe", 2.4f)
                                CelulaCabecalho("Quem", 1.45f)
                            }
                        ) {
                            lista.take(500).forEach { l ->
                                val quem = when {
                                    l.nome.isNotBlank() && l.usuario.isNotBlank() -> "${l.nome}\n${l.usuario}"
                                    l.nome.isNotBlank() -> l.nome
                                    else -> l.usuario.ifBlank { "—" }
                                }
                                LinhaTabela {
                                    Celula(formatDateTimeBr(l.createdAt), 1.2f, linhas = 2)
                                    Celula(l.acaoRotulo, 1.35f, negrito = true, cor = corAcaoLog(l.acao), linhas = 2)
                                    Celula(l.alvo.ifBlank { "—" }, 1.15f, linhas = 2)
                                    Celula(detalheLegivel(l.detalhe), 2.4f, linhas = 3)
                                    Celula(quem, 1.45f, linhas = 2)
                                }
                            }
                        }
                    }
                }
                if (lista.size > 500) Text("Mostrando os 500 mais recentes. Refine a busca.", style = MaterialTheme.typography.bodySmall)
            }
        }
    }
}

// ---------------------------------------------------------------- Fornecedores

@Composable
private fun ListaFornecedores(
    d: AtivosDados,
    scope: CoroutineScope,
    avisar: (String) -> Unit,
    recarregar: () -> Unit
) {
    var editando by remember { mutableStateOf<Fornecedor?>(null) }
    var busca by remember { mutableStateOf("") }
    val porForn = d.ativos.filter { it.emPosse }.groupBy { it.fornecedorId }

    Row(verticalAlignment = Alignment.CenterVertically) {
        Text("Fornecedores", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge, modifier = Modifier.weight(1f))
        if (d.podeEditar("FORNECEDORES")) {
            Button(onClick = { editando = Fornecedor(id = "", nome = "") }, colors = ButtonDefaults.buttonColors(containerColor = Navy)) {
                Text("Novo fornecedor")
            }
        }
    }
    AppOutlinedTextField(
        value = busca,
        onValueChange = { busca = it },
        label = { Text("Buscar fornecedor") },
        singleLine = true,
        modifier = Modifier.fillMaxWidth(),
        colors = FormFieldDefaults.textFieldColors()
    )
    val termo = norm(busca.trim())
    val fornecedores = d.fornecedores
        .filter { termo.isEmpty() || norm("${it.nome} ${it.cnpj} ${it.contato} ${it.telefone} ${it.email}").contains(termo) }
        .sortedBy { it.nome.lowercase() }
    Text("${fornecedores.size} fornecedor(es)", style = MaterialTheme.typography.bodySmall, color = CinzaTexto)
    if (fornecedores.isEmpty()) {
        Text("Nenhum fornecedor encontrado.", color = CinzaTexto)
    } else {
        val podeEditar = d.podeEditar("FORNECEDORES")
        TabelaLarga(1040.dp) {
            TabelaPortal(
                cabecalho = {
                    CelulaCabecalho("Fornecedor", 2f)
                    CelulaCabecalho("CNPJ", 1.3f)
                    CelulaCabecalho("Contato", 2f)
                    CelulaCabecalho("Em posse", 0.9f)
                    CelulaCabecalho("Valor mês", 1.1f)
                    CelulaCabecalho("Situação", 0.9f)
                    if (podeEditar) CelulaCabecalho("", 0.8f)
                }
            ) {
                fornecedores.forEach { f ->
                    val ativos = porForn[f.id].orEmpty()
                    val contato = listOf(f.contato, f.telefone, f.email).filter { it.isNotBlank() }.joinToString("\n").ifBlank { "—" }
                    LinhaTabela {
                        Celula(f.nome, 2f, negrito = true, cor = if (f.ativo) Navy else CinzaTexto, linhas = 2)
                        Celula(f.cnpj.ifBlank { "—" }, 1.3f, linhas = 2)
                        Celula(contato, 2f, linhas = 3)
                        Celula(ativos.size.toString(), 0.9f)
                        Celula(AtivosFormat.moeda(ativos.sumOf { it.valorMes ?: 0.0 }), 1.1f)
                        Celula(if (f.ativo) "Ativo" else "Inativo", 0.9f, cor = if (f.ativo) Verde else PortalCores.Vermelho)
                        if (podeEditar) {
                            Box(Modifier.weight(0.8f)) {
                                TextButton(onClick = { editando = f }) { Text("Editar") }
                            }
                        }
                    }
                }
            }
        }
    }
    editando?.let { f ->
        ModalAtivos(onFechar = { editando = null }) {
            FornecedorForm(f, d.fornecedores, scope, onFechar = { editando = null }, avisar = avisar, recarregar = recarregar)
        }
    }
}

private fun fornecedorComMesmoCnpj(lista: List<Fornecedor>, cnpj: String, ignorarId: String): Fornecedor? {
    val digitos = cnpj.filter { it.isDigit() }
    if (digitos.length < 14) return null
    return lista.firstOrNull { it.id != ignorarId && it.cnpj.filter { c -> c.isDigit() } == digitos }
}

@Composable
private fun FornecedorForm(
    inicial: Fornecedor,
    cadastrados: List<Fornecedor>,
    scope: CoroutineScope,
    onFechar: () -> Unit,
    avisar: (String) -> Unit,
    recarregar: () -> Unit,
    onSalvo: (Fornecedor) -> Unit = {}
) {
    var f by remember(inicial.id) { mutableStateOf(inicial) }
    var salvando by remember { mutableStateOf(false) }
    var erroLocal by remember { mutableStateOf<String?>(null) }
    val cnpjDup = fornecedorComMesmoCnpj(cadastrados, f.cnpj, inicial.id)
    CartaoBranco(Modifier.fillMaxWidth()) {
        BoxWithConstraints(Modifier.fillMaxWidth()) {
            val duas = maxWidth >= 560.dp
            Column(Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                Text(
                    if (inicial.id.isBlank()) "Novo fornecedor" else "Editar fornecedor",
                    fontWeight = FontWeight.Bold,
                    style = MaterialTheme.typography.titleLarge,
                    color = Navy
                )
                Campo("Razão social *", f.nome) { f = f.copy(nome = it) }
                Par(duas,
                    { m -> Campo("CNPJ", f.cnpj, modifier = m) { f = f.copy(cnpj = it); erroLocal = null } },
                    { m -> Campo("Contato", f.contato, modifier = m) { f = f.copy(contato = it) } }
                )
                cnpjDup?.let {
                    Text("CNPJ já cadastrado: ${it.nome}.", color = MaterialTheme.colorScheme.error)
                }
                Par(duas,
                    { m -> Campo("Telefone", f.telefone, modifier = m) { f = f.copy(telefone = it) } },
                    { m -> Campo("E-mail", f.email, modifier = m) { f = f.copy(email = it) } }
                )
                Campo("Observações", f.observacoes, linhas = 2) { f = f.copy(observacoes = it) }
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Checkbox(checked = f.ativo, onCheckedChange = { f = f.copy(ativo = it) })
                    Text("Fornecedor ativo (aparece no cadastro de ativos)")
                }
                erroLocal?.let { Text(it, color = MaterialTheme.colorScheme.error) }
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp, Alignment.End)) {
                    OutlinedButton(onClick = onFechar) { Text("Cancelar") }
                    Button(enabled = !salvando && cnpjDup == null, colors = ButtonDefaults.buttonColors(containerColor = Navy), onClick = {
                        if (f.nome.trim().length < 2) {
                            erroLocal = "Informe o nome do fornecedor."
                            return@Button
                        }
                        val repetido = fornecedorComMesmoCnpj(cadastrados, f.cnpj, inicial.id)
                        if (repetido != null) {
                            erroLocal = "CNPJ já cadastrado: ${repetido.nome}."
                            return@Button
                        }
                        salvando = true
                        scope.launch {
                            AtivosApi.salvarFornecedor(f)
                                .onSuccess {
                                    avisar("Fornecedor ${it.nome} salvo.")
                                    onSalvo(it)
                                    onFechar()
                                    recarregar()
                                }
                                .onFailure { erroLocal = it.message ?: "Falha ao salvar." }
                            salvando = false
                        }
                    }) { Text(if (salvando) "Salvando…" else "Salvar fornecedor") }
                }
            }
        }
    }
}

// ---------------------------------------------------------------- Centros de custo

@Composable
private fun ListaCentros(
    d: AtivosDados,
    scope: CoroutineScope,
    avisar: (String) -> Unit,
    recarregar: () -> Unit
) {
    var editando by remember { mutableStateOf<CentroCusto?>(null) }
    var busca by remember { mutableStateOf("") }
    var soAtivas by remember { mutableStateOf(true) }
    var soMinhas by remember { mutableStateOf(false) }
    var semResponsavel by remember { mutableStateOf(false) }
    val porCc = d.ativos.filter { it.emPosse }.groupBy { it.centroCustoId }
    val termo = norm(busca.trim())
    val lista = d.centrosCusto.filter { c ->
        (!soAtivas || c.ativo) &&
            (!soMinhas || c.engenheiroUsername.equals(d.usuario, true) || c.admUsername.equals(d.usuario, true)) &&
            (!semResponsavel || c.engenheiroUsername.isBlank()) &&
            (termo.isEmpty() || norm(
                "${c.codigo} ${c.nome} ${d.nomeUsuario(c.engenheiroUsername)} ${d.nomeUsuario(c.admUsername)}"
            ).contains(termo))
    }
    br.com.htms.inspeccaocampo.ui.kit.PainelFixo {
        Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Column(Modifier.weight(1f)) {
                    Text("Obras / Centros de custo", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge)
                    Text(
                        "Lista própria do Controle de Ativos (código + nome), no padrão do SIENGE. " +
                            "Ao salvar, o centro entra também no cadastro de obras dos checklists. " +
                            "O admin master define em cada obra o Engenheiro/Supervisor (aprova as solicitações) e o ADM (faz as solicitações).",
                        style = MaterialTheme.typography.bodySmall,
                        color = CinzaTexto
                    )
                }
                if (d.podeEditar("CENTROS") && !d.centrosLimitados) {
                    Button(onClick = { editando = CentroCusto(id = "", codigo = "", nome = "") }, colors = ButtonDefaults.buttonColors(containerColor = Navy)) {
                        Text("Novo centro de custo")
                    }
                }
            }
            CampoBusca(busca, { busca = it }, "Filtrar obras por código, nome ou responsável", Modifier.fillMaxWidth())
            Row(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                FilterChip(selected = soAtivas, onClick = { soAtivas = !soAtivas }, label = { Text("Somente ativas") })
                FilterChip(selected = soMinhas, onClick = { soMinhas = !soMinhas }, label = { Text("Minhas obras") })
                FilterChip(selected = semResponsavel, onClick = { semResponsavel = !semResponsavel }, label = { Text("Sem Eng./Sup.") })
            }
            Text("${lista.size} obra(s)", style = MaterialTheme.typography.bodySmall, color = CinzaTexto)
        }
    }
    CartaoBranco(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(8.dp)) {
            if (lista.isEmpty()) Text("Nenhuma obra encontrada.", Modifier.padding(8.dp), color = CinzaTexto)
            lista.forEach { c ->
                val ativos = porCc[c.id].orEmpty()
                Row(Modifier.fillMaxWidth().padding(horizontal = 8.dp, vertical = 6.dp), verticalAlignment = Alignment.CenterVertically) {
                    Text(c.codigo, Modifier.width(60.dp), fontWeight = FontWeight.Bold, color = Navy)
                    Column(Modifier.weight(1f)) {
                        Text(c.nome + if (!c.ativo) " (inativo)" else "", style = MaterialTheme.typography.bodyMedium)
                        val resp = buildList {
                            if (c.engenheiroUsername.isNotBlank()) add("Eng./Sup.: ${d.nomeUsuario(c.engenheiroUsername)}")
                            if (c.admUsername.isNotBlank()) add("ADM: ${d.nomeUsuario(c.admUsername)}")
                        }
                        if (resp.isNotEmpty()) Text(resp.joinToString(" · "), style = MaterialTheme.typography.bodySmall, color = CinzaTexto)
                    }
                    Text(
                        "${ativos.size} ativo(s) · ${AtivosFormat.moeda(ativos.filter { it.alugado }.sumOf { it.valorMes ?: 0.0 })}/mês",
                        style = MaterialTheme.typography.bodySmall,
                        color = CinzaTexto
                    )
                    if (d.podeEditar("CENTROS")) TextButton(onClick = { editando = c }) { Text("Editar") }
                }
                HorizontalDivider(color = Color(0xFFE6E9EF))
            }
        }
    }
    editando?.let { c ->
        ModalAtivos(onFechar = { editando = null }) {
            CentroForm(c, d, scope, onFechar = { editando = null }, avisar = avisar, recarregar = recarregar)
        }
    }
}

@Composable
private fun CentroForm(
    inicial: CentroCusto,
    d: AtivosDados,
    scope: CoroutineScope,
    onFechar: () -> Unit,
    avisar: (String) -> Unit,
    recarregar: () -> Unit
) {
    var c by remember(inicial.id) { mutableStateOf(inicial) }
    var salvando by remember { mutableStateOf(false) }
    var erroLocal by remember { mutableStateOf<String?>(null) }
    CartaoBranco(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
            Text(
                if (inicial.id.isBlank()) "Novo centro de custo" else "Editar centro de custo",
                fontWeight = FontWeight.Bold,
                style = MaterialTheme.typography.titleLarge,
                color = Navy
            )
            Text(
                "Padrão do SIENGE (sistema do financeiro): código numérico e o nome oficial do centro de custo. " +
                    "Ao salvar, o cadastro entra no banco de centros de custo e no banco de obras.",
                style = MaterialTheme.typography.bodySmall,
                color = CinzaTexto
            )
            Campo("Código *", c.codigo, numero = true) { c = c.copy(codigo = it.filter { ch -> ch.isDigit() }) }
            Campo("Nome *", c.nome) { c = c.copy(nome = it) }
            if (d.master) {
                fun rotulo(u: br.com.htms.inspeccaocampo.data.ativos.UsuarioAtivos) =
                    u.rotulo + if (!u.liberado) " · sem acesso ao módulo" else ""
                Seletor(
                    label = "Engenheiro / Supervisor (aprova as solicitações)",
                    opcoes = listOf("" to "Não definido") + d.usuarios.filter { it.engSup }.map { it.username to rotulo(it) },
                    selecionado = c.engenheiroUsername,
                    onSelect = { c = c.copy(engenheiroUsername = it) }
                )
                Seletor(
                    label = "ADM da obra (faz as solicitações de movimentação)",
                    opcoes = listOf("" to "Não definido") +
                        (d.usuariosAdm + d.usuarios.filter { it.username.equals(c.admUsername, true) && it !in d.usuariosAdm })
                            .map { it.username to rotulo(it) },
                    selecionado = c.admUsername,
                    onSelect = { c = c.copy(admUsername = it) }
                )
                Text(
                    "Lista os usuários com TAG Engenheiro/Supervisor e, para ADM, só os usuários com TAG ADM (sem os administradores do sistema). Sem Engenheiro/Supervisor definido, " +
                        "qualquer usuário com essa TAG pode aprovar. Quem estiver \"sem acesso ao módulo\" precisa receber o acesso " +
                        "Controle de Ativos no cadastro (Config → Usuários).",
                    style = MaterialTheme.typography.bodySmall,
                    color = CinzaTexto
                )
            } else if (c.engenheiroUsername.isNotBlank() || c.admUsername.isNotBlank()) {
                Text(
                    "Eng./Sup.: ${d.nomeUsuario(c.engenheiroUsername).ifBlank { "-" }} · ADM: ${d.nomeUsuario(c.admUsername).ifBlank { "-" }} (definidos pelo admin master)",
                    style = MaterialTheme.typography.bodySmall,
                    color = CinzaTexto
                )
            }
            Row(verticalAlignment = Alignment.CenterVertically) {
                Checkbox(checked = c.ativo, onCheckedChange = { c = c.copy(ativo = it) })
                Text("Ativo (aparece nas listas de escolha)")
            }
            erroLocal?.let { Text(it, color = MaterialTheme.colorScheme.error) }
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp, Alignment.End)) {
                OutlinedButton(onClick = onFechar) { Text("Cancelar") }
                Button(enabled = !salvando, colors = ButtonDefaults.buttonColors(containerColor = Navy), onClick = {
                    if (c.codigo.isBlank() || c.nome.trim().length < 3) {
                        erroLocal = "Cadastre no padrão do SIENGE: código numérico e o nome oficial do centro de custo."
                        return@Button
                    }
                    salvando = true
                    scope.launch {
                        AtivosApi.salvarCentroCusto(c)
                            .onSuccess {
                                avisar("Centro de custo ${it.rotulo} salvo.")
                                onFechar()
                                recarregar()
                            }
                            .onFailure { erroLocal = it.message ?: "Falha ao salvar." }
                        salvando = false
                    }
                }) { Text(if (salvando) "Salvando…" else "Salvar") }
            }
        }
    }
}

// ---------------------------------------------------------------- Solicitações

@Composable
private fun LocacaoForm(
    d: AtivosDados,
    scope: CoroutineScope,
    onFechar: () -> Unit,
    avisar: (String) -> Unit,
    recarregar: () -> Unit,
    onVoltar: (() -> Unit)? = null
) {
    val minhaObra = d.centrosCusto.firstOrNull { it.ativo && it.admUsername.equals(d.usuario, true) }?.id.orEmpty()
    var obra by remember { mutableStateOf(minhaObra) }
    var veiculo by remember { mutableStateOf("") }
    var inicio by remember { mutableStateOf(DateInputMask.now(DateFieldKind.DATE)) }
    var fim by remember { mutableStateOf("") }
    var justificativa by remember { mutableStateOf("") }
    var condutor by remember { mutableStateOf("") }
    var obs by remember { mutableStateOf("") }
    var salvando by remember { mutableStateOf(false) }
    var erroLocal by remember { mutableStateOf<String?>(null) }
    val direto = obra.isNotBlank() && d.aprovaObra(obra)

    CartaoBranco(Modifier.fillMaxWidth()) {
        BoxWithConstraints(Modifier.fillMaxWidth()) {
            val duas = maxWidth >= 560.dp
            Column(Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                Text("Solicitar locação de veículo", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge, color = Navy)
                Text(
                    "Fluxo: ADM solicita → Engenheiro/Supervisor da obra aprova → Coordenador de Frotas providencia.",
                    style = MaterialTheme.typography.bodySmall,
                    color = CinzaTexto
                )
                SeletorBusca(
                    label = "Obra / centro de custo *",
                    opcoes = listOf("" to "—") + d.centrosCusto.filter { it.ativo }.map { it.id to it.rotulo },
                    selecionado = obra,
                    onSelect = { obra = it }
                )
                Campo("Tipo de veículo * (ex.: caminhonete 4x4, van, caminhão munck)", veiculo) { veiculo = it }
                Par(duas,
                    { m -> AppDateTextField(value = inicio, onValueChange = { inicio = it }, label = "Início *", modifier = m) },
                    { m -> AppDateTextField(value = fim, onValueChange = { fim = it }, label = "Previsão de término", modifier = m) }
                )
                Campo("Justificativa / finalidade *", justificativa, linhas = 3) { justificativa = it }
                CampoColaborador("Condutor / responsável pelo veículo", condutor, d.colaboradores) { condutor = it }
                Campo("Observação", obs, linhas = 2) { obs = it }
                if (obra.isNotBlank()) {
                    Text(
                        if (direto) "Você aprova esta obra: a solicitação segue direto para o Coordenador de Frotas."
                        else "A solicitação vai para aprovação do Engenheiro/Supervisor da obra.",
                        style = MaterialTheme.typography.bodySmall,
                        color = if (direto) Verde else Laranja
                    )
                }
                erroLocal?.let { Text(it, color = MaterialTheme.colorScheme.error) }
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp, Alignment.End)) {
                    if (onVoltar != null) TextButton(onClick = onVoltar) { Text("Voltar") }
                    OutlinedButton(onClick = onFechar) { Text("Cancelar") }
                    Button(
                        enabled = !salvando,
                        colors = ButtonDefaults.buttonColors(containerColor = Navy),
                        onClick = {
                            val ini = AtivosFormat.dataIso(inicio)
                            val fimIso = AtivosFormat.dataIso(fim)
                            erroLocal = when {
                                obra.isBlank() -> "Escolha a obra / centro de custo."
                                veiculo.trim().length < 3 -> "Informe o tipo de veículo."
                                ini.isNullOrBlank() -> "Informe a data de início (dd/mm/aaaa)."
                                fimIso == null -> "Previsão de término inválida (dd/mm/aaaa)."
                                fimIso.isNotBlank() && fimIso < ini -> "O término não pode ser antes do início."
                                justificativa.trim().length < 5 -> "Informe a justificativa / finalidade."
                                else -> null
                            }
                            if (erroLocal != null) return@Button
                            salvando = true
                            scope.launch {
                                AtivosApi.solicitarLocacao(obra, veiculo.trim(), ini!!, fimIso!!, justificativa.trim(), condutor.trim(), obs.trim())
                                    .onSuccess { s ->
                                        avisar(
                                            if (s.status == "AGUARDANDO_FROTAS") "Locação aprovada e enviada ao Coordenador de Frotas."
                                            else "Solicitação de locação enviada para aprovação do Engenheiro/Supervisor da obra."
                                        )
                                        onFechar()
                                        recarregar()
                                    }
                                    .onFailure { erroLocal = it.message ?: "Falha ao enviar." }
                                salvando = false
                            }
                        }
                    ) { Text(if (salvando) "Enviando…" else "Enviar solicitação") }
                }
            }
        }
    }
}

private fun corSolic(status: String): Pair<Color, Color> = when (status) {
    "PENDENTE" -> Color(0xFFD06A00) to Color(0xFFFFF3E5)
    "DEVOLVIDA" -> Color(0xFF7B4FC9) to Color(0xFFF1EBFB)
    "AGUARDANDO_FROTAS" -> Color(0xFF1E5AA8) to Color(0xFFE7F0FB)
    "APROVADA", "ATENDIDA" -> Color(0xFF1E7B3A) to Color(0xFFE8F5EC)
    "REPROVADA" -> Color(0xFFC62828) to Color(0xFFFDECEC)
    else -> Color(0xFF5B6575) to Color(0xFFF0F2F5)
}

private enum class FiltroSolic(val rotulo: String) {
    PARA_MIM("Aguardando minha ação"),
    ABERTAS("Em aberto"),
    MINHAS("Minhas solicitações"),
    TODAS("Todas")
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun ListaSolicitacoes(
    d: AtivosDados,
    scope: CoroutineScope,
    avisar: (String) -> Unit,
    recarregar: () -> Unit,
    onNovaLocacao: () -> Unit
) {
    val paraMim = d.pendentesParaMim()
    var filtro by remember { mutableStateOf(if (paraMim.isNotEmpty()) FiltroSolic.PARA_MIM else FiltroSolic.ABERTAS) }
    var filtroCc by remember { mutableStateOf("") }
    var filtroTipo by remember { mutableStateOf("") }
    var busca by remember { mutableStateOf("") }
    var acao by remember { mutableStateOf<Pair<Solicitacao, String>?>(null) }
    val ccPorId = d.centrosCusto.associateBy { it.id }
    val ativoPorId = d.ativos.associateBy { it.id }

    if (d.master) ConfigFrotas(d, scope, avisar, recarregar)

    CartaoBranco(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            val idsParaMim = paraMim.map { it.id }.toSet()
            val termo = norm(busca.trim())
            val lista = d.solicitacoes.filter { s ->
                when (filtro) {
                    FiltroSolic.PARA_MIM -> s.id in idsParaMim
                    FiltroSolic.ABERTAS -> s.aberta
                    FiltroSolic.MINHAS -> s.solicitante.equals(d.usuario, true)
                    FiltroSolic.TODAS -> true
                } &&
                    (filtroCc == "" || s.centroCustoId == filtroCc || s.paraCentroCustoId == filtroCc) &&
                    (filtroTipo == "" || s.tipo == filtroTipo) &&
                    (termo.isEmpty() || norm(
                        listOf(
                            ativoPorId[s.ativoId]?.codigo.orEmpty(), ativoPorId[s.ativoId]?.descricao.orEmpty(),
                            s.veiculo, s.solicitanteRotulo, s.observacao, s.justificativa, s.condutor, s.responsavel
                        ).joinToString(" ")
                    ).contains(termo))
            }
            br.com.htms.inspeccaocampo.ui.kit.PainelFixo {
            Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            FlowRow(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.fillMaxWidth()) {
                Text("Solicitações", color = Navy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge, modifier = Modifier.padding(end = 20.dp, top = 8.dp))
                if (d.podeEditar("SOLICITACOES")) Button(onClick = onNovaLocacao, colors = ButtonDefaults.buttonColors(containerColor = Navy), shape = RoundedCornerShape(10.dp)) {
                    Icon(Icons.Filled.Add, contentDescription = null, modifier = Modifier.size(18.dp))
                    Spacer(Modifier.width(6.dp))
                    Text("Solicitar locação de veículo")
                }
            }
            Text(
                "Movimentações feitas por quem não é o Engenheiro/Supervisor da obra chegam aqui para aprovar, reprovar ou devolver para confirmação. " +
                    "Locações aprovadas seguem para o Coordenador de Frotas" +
                    (if (d.frotasUsername.isNotBlank()) " (${d.nomeUsuario(d.frotasUsername)})." else "."),
                style = MaterialTheme.typography.bodySmall,
                color = CinzaTexto
            )
            FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                FiltroSolic.entries.forEach { f ->
                    val rot = if (f == FiltroSolic.PARA_MIM) "${f.rotulo} (${paraMim.size})" else f.rotulo
                    FilterChip(selected = filtro == f, onClick = { filtro = f }, label = { Text(rot) })
                }
            }
            FlowRow(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
                FiltroObra(d, filtroCc) { filtroCc = it }
                Box(Modifier.widthIn(min = 220.dp, max = 300.dp)) {
                    Seletor(
                        label = "Tipo",
                        opcoes = listOf("" to "Todos", "MOV" to "Movimentação", "LOCACAO" to "Locação de veículo"),
                        selecionado = filtroTipo,
                        onSelect = { filtroTipo = it }
                    )
                }
            }
            CampoBusca(busca, { busca = it }, "Buscar (ativo, veículo, solicitante, observação)", Modifier.fillMaxWidth())
            Text("${lista.size} solicitação(ões)", style = MaterialTheme.typography.bodySmall, color = CinzaTexto)
            }
            }
            lista.forEach { s ->
                CartaoSolicitacao(s, d, ccPorId, ativoPorId[s.ativoId]) { tipoAcao -> acao = s to tipoAcao }
            }
            if (lista.isEmpty()) {
                Text(
                    if (filtro == FiltroSolic.PARA_MIM) "Nada aguardando sua ação." else "Nenhuma solicitação encontrada.",
                    color = CinzaTexto
                )
            }
        }
    }

    acao?.let { (s, tipoAcao) ->
        AcaoSolicitacaoDialog(s, tipoAcao, scope, onFechar = { acao = null }, avisar = avisar, recarregar = recarregar)
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun CartaoSolicitacao(
    s: Solicitacao,
    d: AtivosDados,
    ccPorId: Map<String, CentroCusto>,
    ativo: Ativo?,
    onAcao: (String) -> Unit
) {
    var verHistorico by remember { mutableStateOf(false) }
    val (cor, fundo) = corSolic(s.status)
    Column(
        Modifier.fillMaxWidth().border(1.dp, Borda, RoundedCornerShape(12.dp)).padding(14.dp),
        verticalArrangement = Arrangement.spacedBy(6.dp)
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Text(
                if (s.locacao) "Locação de veículo" else MovimentacaoTipo.rotulo(s.movTipo),
                Modifier.weight(1f),
                color = Navy,
                fontWeight = FontWeight.Bold
            )
            Box(Modifier.background(fundo, RoundedCornerShape(50)).border(1.dp, cor.copy(alpha = 0.4f), RoundedCornerShape(50)).padding(horizontal = 10.dp, vertical = 3.dp)) {
                Text(SolicStatus.rotulo(s.status), color = cor, style = MaterialTheme.typography.labelMedium, fontWeight = FontWeight.SemiBold)
            }
        }
        Text("Obra: ${ccPorId[s.centroCustoId]?.rotulo ?: "-"}", style = MaterialTheme.typography.bodyMedium)
        if (s.locacao) {
            Text("Veículo: ${s.veiculo}", fontWeight = FontWeight.SemiBold)
            Text(
                "Período: ${AtivosFormat.dataBr(s.dataInicio)}" + (if (s.dataFim.isNotBlank()) " até ${AtivosFormat.dataBr(s.dataFim)}" else " (sem previsão de término)") +
                    (if (s.condutor.isNotBlank()) " · Condutor: ${s.condutor}" else ""),
                style = MaterialTheme.typography.bodySmall
            )
            Text("Justificativa: ${s.justificativa}", style = MaterialTheme.typography.bodySmall)
        } else {
            Text(ativo?.let { "${it.codigo} · ${it.descricao}" } ?: "Ativo removido", fontWeight = FontWeight.SemiBold)
            Text(
                buildList {
                    if (s.paraCentroCustoId.isNotBlank()) add("Para: ${ccPorId[s.paraCentroCustoId]?.rotulo ?: "-"}")
                    if (s.responsavel.isNotBlank()) add("Responsável: ${s.responsavel}")
                    if (s.data.isNotBlank()) add("Data: ${AtivosFormat.dataBr(s.data)}")
                }.joinToString(" · "),
                style = MaterialTheme.typography.bodySmall
            )
        }
        if (s.observacao.isNotBlank()) Text("Obs.: ${s.observacao}", style = MaterialTheme.typography.bodySmall, color = CinzaTexto)
        Text(
            "Solicitado por ${s.solicitanteRotulo} em ${formatDateTimeBr(s.createdAt)}",
            style = MaterialTheme.typography.bodySmall,
            color = CinzaTexto
        )
        s.historico.lastOrNull { it.obs.isNotBlank() && it.acao != "CRIADA" }?.let { ev ->
            Text(
                "${SolicStatus.rotuloEvento(ev.acao)} por ${d.nomeUsuario(ev.por)}: ${ev.obs}",
                style = MaterialTheme.typography.bodySmall,
                color = Color(0xFF7B4FC9)
            )
        }
        FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
            if (d.podeDecidir(s)) {
                Button(onClick = { onAcao("APROVAR") }, colors = ButtonDefaults.buttonColors(containerColor = Verde)) { Text("Aprovar") }
                OutlinedButton(onClick = { onAcao("DEVOLVER") }) { Text("Devolver para confirmação", color = Color(0xFF7B4FC9)) }
                OutlinedButton(onClick = { onAcao("REPROVAR") }) { Text("Reprovar", color = Color(0xFFC62828)) }
            }
            if (d.podeAtender(s)) {
                Button(onClick = { onAcao("ATENDER") }, colors = ButtonDefaults.buttonColors(containerColor = Navy)) { Text("Marcar como atendida") }
            }
            if (s.status == "DEVOLVIDA" && d.ehDono(s)) {
                Button(onClick = { onAcao("REENVIAR") }, colors = ButtonDefaults.buttonColors(containerColor = Navy)) { Text("Confirmar e reenviar") }
            }
            if ((s.status == "PENDENTE" || s.status == "DEVOLVIDA") && d.ehDono(s)) {
                TextButton(onClick = { onAcao("CANCELAR") }) { Text("Cancelar solicitação", color = Color(0xFFC62828)) }
            }
            TextButton(onClick = { verHistorico = !verHistorico }) { Text(if (verHistorico) "Ocultar histórico" else "Histórico") }
        }
        if (verHistorico) {
            s.historico.forEach { ev ->
                Text(
                    "${formatDateTimeBr(ev.em)} · ${SolicStatus.rotuloEvento(ev.acao)} por ${d.nomeUsuario(ev.por)}" +
                        if (ev.obs.isNotBlank()) " — ${ev.obs}" else "",
                    style = MaterialTheme.typography.bodySmall,
                    color = CinzaTexto
                )
            }
        }
    }
}

@Composable
private fun AcaoSolicitacaoDialog(
    s: Solicitacao,
    acao: String,
    scope: CoroutineScope,
    onFechar: () -> Unit,
    avisar: (String) -> Unit,
    recarregar: () -> Unit
) {
    var obs by remember { mutableStateOf("") }
    var enviando by remember { mutableStateOf(false) }
    var erro by remember { mutableStateOf<String?>(null) }
    val obrigatoria = acao == "REPROVAR" || acao == "DEVOLVER"
    val (titulo, texto, botao) = when (acao) {
        "APROVAR" -> Triple(
            "Aprovar solicitação?",
            if (s.locacao) "A locação segue para o Coordenador de Frotas, que recebe um e-mail."
            else "A movimentação é aplicada no ativo agora.",
            "Aprovar"
        )
        "REPROVAR" -> Triple("Reprovar solicitação?", "A solicitação é encerrada. Explique o motivo ao solicitante.", "Reprovar")
        "DEVOLVER" -> Triple("Devolver para confirmação?", "O solicitante/ADM corrige ou confirma e reenvia. Diga o que precisa ser confirmado.", "Devolver")
        "REENVIAR" -> Triple("Reenviar para aprovação?", "Responda ao que foi pedido na devolução.", "Reenviar")
        "CANCELAR" -> Triple("Cancelar solicitação?", "A solicitação é encerrada sem efeito.", "Cancelar solicitação")
        else -> Triple("Marcar como atendida?", "Informe o que foi providenciado (locadora, placa, data de entrega…).", "Marcar como atendida")
    }
    AlertDialog(
        onDismissRequest = { if (!enviando) onFechar() },
        title = { Text(titulo) },
        text = {
            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                Text(texto, style = MaterialTheme.typography.bodyMedium)
                Campo(if (obrigatoria) "Motivo *" else "Comentário (opcional)", obs, linhas = 3) { obs = it }
                erro?.let { Text(it, color = MaterialTheme.colorScheme.error) }
            }
        },
        confirmButton = {
            Button(
                enabled = !enviando,
                colors = ButtonDefaults.buttonColors(
                    containerColor = when (acao) {
                        "APROVAR" -> Verde
                        "REPROVAR", "CANCELAR" -> Color(0xFFC62828)
                        else -> Navy
                    }
                ),
                onClick = {
                    if (obrigatoria && obs.trim().length < 3) {
                        erro = "Escreva o motivo."
                        return@Button
                    }
                    enviando = true
                    scope.launch {
                        AtivosApi.acaoSolicitacao(s.id, acao, obs.trim())
                            .onSuccess { r ->
                                avisar("Solicitação: ${SolicStatus.rotulo(r.status).lowercase()}.")
                                onFechar()
                                recarregar()
                            }
                            .onFailure { erro = it.message ?: "Falha ao enviar." }
                        enviando = false
                    }
                }
            ) { Text(if (enviando) "Enviando…" else botao) }
        },
        dismissButton = { TextButton(onClick = onFechar, enabled = !enviando) { Text("Voltar") } }
    )
}

@Composable
private fun ConfigFrotas(d: AtivosDados, scope: CoroutineScope, avisar: (String) -> Unit, recarregar: () -> Unit) {
    var usuario by remember(d.frotasUsername) { mutableStateOf(d.frotasUsername) }
    var email by remember(d.frotasEmail) { mutableStateOf(d.frotasEmail) }
    var salvando by remember { mutableStateOf(false) }
    var erro by remember { mutableStateOf<String?>(null) }
    CartaoBranco(Modifier.fillMaxWidth()) {
        BoxWithConstraints(Modifier.fillMaxWidth()) {
            val duas = maxWidth >= 640.dp
            Column(Modifier.padding(20.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                Text("Coordenador de Frotas (somente admin master)", color = Navy, fontWeight = FontWeight.Bold)
                Text(
                    "Recebe as locações de veículo aprovadas: vê em Solicitações, marca como atendida e recebe um e-mail.",
                    style = MaterialTheme.typography.bodySmall,
                    color = CinzaTexto
                )
                Par(duas,
                    { m ->
                        Seletor(
                            label = "Usuário",
                            opcoes = listOf("" to "Não definido") + d.usuarios.filter { it.liberado }.map { it.username to it.rotulo },
                            selecionado = usuario,
                            onSelect = { usuario = it },
                            modifier = m
                        )
                    },
                    { m -> Campo("E-mail para aviso (separe vários por vírgula)", email, modifier = m) { email = it } }
                )
                erro?.let { Text(it, color = MaterialTheme.colorScheme.error) }
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End) {
                    Button(
                        enabled = !salvando && (usuario != d.frotasUsername || email != d.frotasEmail),
                        colors = ButtonDefaults.buttonColors(containerColor = Navy),
                        onClick = {
                            salvando = true
                            erro = null
                            scope.launch {
                                AtivosApi.salvarConfig(usuario, email.trim())
                                    .onSuccess {
                                        avisar("Coordenador de Frotas salvo.")
                                        recarregar()
                                    }
                                    .onFailure { erro = it.message ?: "Falha ao salvar." }
                                salvando = false
                            }
                        }
                    ) { Text(if (salvando) "Salvando…" else "Salvar") }
                }
            }
        }
    }
}

// ---------------------------------------------------------------- Componentes

@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun CampoColaborador(
    label: String,
    valor: String,
    colaboradores: List<Colaborador>,
    modifier: Modifier = Modifier.fillMaxWidth(),
    onChange: (String) -> Unit
) {
    var aberto by remember { mutableStateOf(false) }
    val termo = norm(valor.trim())
    val sugestoes = colaboradores.filter { termo.isEmpty() || norm(it.nome).contains(termo) }.take(40)
    val mostrar = aberto && sugestoes.isNotEmpty()
    ExposedDropdownMenuBox(expanded = mostrar, onExpandedChange = { aberto = it }, modifier = modifier) {
        AppOutlinedTextField(
            value = valor,
            onValueChange = {
                onChange(it)
                aberto = true
            },
            singleLine = true,
            label = { Text(label) },
            trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = mostrar) },
            modifier = Modifier.fillMaxWidth().menuAnchor(),
            colors = FormFieldDefaults.textFieldColors()
        )
        DropdownMenu(
            expanded = mostrar,
            onDismissRequest = { aberto = false },
            properties = PopupProperties(focusable = false),
            modifier = Modifier.exposedDropdownSize()
        ) {
            sugestoes.forEach { c ->
                DropdownMenuItem(
                    text = {
                        Column {
                            Text(c.nome)
                            if (c.cargo.isNotBlank()) Text(c.cargo, style = MaterialTheme.typography.bodySmall, color = CinzaTexto)
                        }
                    },
                    onClick = {
                        onChange(c.nome)
                        aberto = false
                    }
                )
            }
        }
    }
}

@Composable
private fun ConfirmarExclusaoMov(
    m: Movimentacao,
    ativo: Ativo?,
    scope: CoroutineScope,
    onFechar: () -> Unit,
    avisar: (String) -> Unit,
    recarregar: () -> Unit
) {
    var excluindo by remember { mutableStateOf(false) }
    var erro by remember { mutableStateOf<String?>(null) }
    AlertDialog(
        onDismissRequest = { if (!excluindo) onFechar() },
        title = { Text("Excluir movimentação?") },
        text = {
            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                Text(
                    "${MovimentacaoTipo.rotulo(m.tipo)} de ${ativo?.let { "${it.codigo} - ${it.descricao}" } ?: "ativo removido"}" +
                        " em ${AtivosFormat.dataBr(m.data)}."
                )
                Text(
                    "Se for a última movimentação do ativo, ele volta para o local e o status anteriores. " +
                        "A exclusão fica registrada no log de acessos.",
                    style = MaterialTheme.typography.bodySmall,
                    color = CinzaTexto
                )
                erro?.let { Text(it, color = MaterialTheme.colorScheme.error) }
            }
        },
        confirmButton = {
            Button(
                enabled = !excluindo,
                colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFC62828)),
                onClick = {
                    excluindo = true
                    scope.launch {
                        AtivosApi.removerMovimentacao(m.id)
                            .onSuccess {
                                avisar("Movimentação excluída.")
                                onFechar()
                                recarregar()
                            }
                            .onFailure { erro = it.message ?: "Falha ao excluir." }
                        excluindo = false
                    }
                }
            ) { Text(if (excluindo) "Excluindo..." else "Excluir") }
        },
        dismissButton = { TextButton(onClick = onFechar, enabled = !excluindo) { Text("Cancelar") } }
    )
}